import baiduMapStyleJson from './baiduMapStyleJson.json';

export const MAX_CLIENT_WIDTH = 500;
export const MAP_STYLE_JSON = baiduMapStyleJson;

export function getEnumsLabel(code, map, formatMessage) {
    if (code && code !== '') {
        if (map[code]) {
            return formatMessage({ id: map[code] });
        }
    }
    return "";
}

export const LESSOR_CONTACT_POSITION_TYPE = {

    // CASH: "01",
    // CARD: "02",
    // WECHAT: "03",
    // ALIPAY: "04",
    properties: {
        "01": { label: "租赁经理（项目租赁）", code: "01" },
        "02": { label: "租赁总监（区域租赁负责人）", code: "02" },
        "03": { label: "管理层", code: "03" },
        "04": { label: "法务", code: "04" },
        "05": { label: "工程及规划", code: "05" },
    },
    getLabel: (value) => {
        let property = LESSOR_CONTACT_POSITION_TYPE.properties[value];
        if (property) {
            return property.label;
        } else {
            return "无"
        }
    }
};

export const CONTACTS_POSITION = {
    List: [
        { value: "01", label: "WMS_CONTACTS_FIELD_POSITION_LEASING_MANAGER" },
        { value: "02", label: "WMS_CONTACTS_FIELD_POSITION_LEASING_DIRECTOR" },
        { value: "03", label: "WMS_CONTACTS_FIELD_POSITION_MANAGER" },
        { value: "04", label: "WMS_CONTACTS_FIELD_POSITION_LEGAL" },
        { value: "05", label: "WMS_CONTACTS_FIELD_POSITION_PROJECT" },
        { value: "06", label: "WMS_CONTACTS_FIELD_INVESTMENT_DEVELOPMENT" },
        { value: "07", label: "WMS_CONTACTS_FIELD_ASSET_MANAGEMENT" },
    ],
    Map: {
        "01": "WMS_CONTACTS_FIELD_POSITION_LEASING_MANAGER",
        "02": "WMS_CONTACTS_FIELD_POSITION_LEASING_DIRECTOR",
        "03": "WMS_CONTACTS_FIELD_POSITION_MANAGER",
        "04": "WMS_CONTACTS_FIELD_POSITION_LEGAL",
        "05": "WMS_CONTACTS_FIELD_POSITION_PROJECT",
        "06": "WMS_CONTACTS_FIELD_INVESTMENT_DEVELOPMENT",
        "07": "WMS_CONTACTS_FIELD_ASSET_MANAGEMENT",
    },
    Enum: {
        LeasingManager: "01",
        LeasingDirector: "02",
        Manager: "03",
        Legal: "04",
        Project: "05",
        InvestmentDevelopment: "06",
        AssetManagement: "07"
    }
};

export const FOLLOWUP_WAY = {
    List: [
        { value: "03", label: "WMS_FOLLOWUP_FIELD_FOLLOW_PHONE_QQ" },
        { value: "04", label: "WMS_FOLLOWUP_FIELD_FOLLOW_EMAIL" },
        { value: "05", label: "WMS_FOLLOWUP_FIELD_FOLLOW_VISIT_FACE" }
    ],
    Map: {
        "03": "WMS_FOLLOWUP_FIELD_FOLLOW_PHONE_QQ",
        "04": "WMS_FOLLOWUP_FIELD_FOLLOW_EMAIL",
        "05": "WMS_FOLLOWUP_FIELD_FOLLOW_VISIT_FACE"
    },
    Enum: {
        phone: "03",
        email: "04",
        visit: "05"
    }
};

export const SHOW_MAPS = {
    List: [
        { value: "01", label: "WMS_ZONE_MSG_PIPELINE_MAP" },
        { value: "02", label: "WMS_ZONE_MSG_SATELLITE_MAP" },
        { value: "03", label: "WMS_ZONE_MSG_GOOGLE_MAP" }
    ],
    Map: {
        "01": "WMS_ZONE_MSG_PIPELINE_MAP",
        "02": "WMS_ZONE_MSG_SATELLITE_MAP",
        "03": "WMS_ZONE_MSG_GOOGLE_MAP"
    },
    Enum: {
        pipeline: "01",
        satellite: "02",
        google: "03"
    }
};

export const CONTACTS_REGION = {
    List: [
        { value: "01", label: "WMS_CONTACTS_FIELD_REGION_EAST" },
        { value: "02", label: "WMS_CONTACTS_FIELD_REGION_SOUTH" },
        { value: "03", label: "WMS_CONTACTS_FIELD_REGION_NORTH" },
        { value: "04", label: "WMS_CONTACTS_FIELD_REGION_CENTRAL" },
        { value: "05", label: "WMS_CONTACTS_FIELD_REGION_SOUTHWEST" },
        { value: "06", label: "WMS_CONTACTS_FIELD_REGION_NORTHWEST" },
        { value: "07", label: "WMS_CONTACTS_FIELD_REGION_NORTHEAST" }
    ],
    Map: {
        "01": "WMS_CONTACTS_FIELD_REGION_EAST",
        "02": "WMS_CONTACTS_FIELD_REGION_SOUTH",
        "03": "WMS_CONTACTS_FIELD_REGION_NORTH",
        "04": "WMS_CONTACTS_FIELD_REGION_CENTRAL",
        "05": "WMS_CONTACTS_FIELD_REGION_SOUTHWEST",
        "06": "WMS_CONTACTS_FIELD_REGION_NORTHWEST",
        "07": "WMS_CONTACTS_FIELD_REGION_NORTHEAST"
    },
    Enum: {
        east: "01",
        south: "02",
        north: "03",
        central: "04",
        southwest: "05",
        northwest: "06",
        northeast: "07"
    }
};

export const CONTACTS_POSITION_02 = {
    List: [
        { value: "01", label: "WMS_CONTACTS_FIELD_POSITION_PROCUREMENT" },
        { value: "02", label: "WMS_CONTACTS_FIELD_POSITION_SALES" },
        { value: "03", label: "WMS_CONTACTS_FIELD_POSITION_PLAN_AND_SCHEME" },
        { value: "04", label: "WMS_CONTACTS_FIELD_POSITION_FINANCIAL" },
        { value: "05", label: "WMS_CONTACTS_FIELD_POSITION_LEGAL" },
        { value: "06", label: "WMS_CONTACTS_FIELD_POSITION_OPERATING" },
        { value: "07", label: "WMS_CONTACTS_FIELD_POSITION_ADMINISTRATIVE" },
        { value: "08", label: "WMS_CONTACTS_FIELD_POSITION_MANAGER" },
    ],
    Map: {
        "01": "WMS_CONTACTS_FIELD_POSITION_PROCUREMENT",
        "02": "WMS_CONTACTS_FIELD_POSITION_SALES",
        "03": "WMS_CONTACTS_FIELD_POSITION_PLAN_AND_SCHEME",
        "04": "WMS_CONTACTS_FIELD_POSITION_FINANCIAL",
        "05": "WMS_CONTACTS_FIELD_POSITION_LEGAL",
        "06": "WMS_CONTACTS_FIELD_POSITION_OPERATING",
        "07": "WMS_CONTACTS_FIELD_POSITION_ADMINISTRATIVE",
        "08": "WMS_CONTACTS_FIELD_POSITION_MANAGER",
    },
    Enum: {
        procurement: "01",
        sales: "02",
        PlanAndScheme: "03",
        financial: "04",
        legal: "05",
        operating: "06",
        administrative: "07",
        management: "08"
    }
};

export const ZoneType = {
    List: [
        { value: "01", label: "WMS_ZONE_FIELD_TYPE_BUSINESS" },
        { value: "02", label: "WMS_ZONE_FIELD_TYPE_SELF" },
    ],

    Map: {
        "01": "WMS_ZONE_FIELD_TYPE_BUSINESS",
        "02": "WMS_ZONE_FIELD_TYPE_SELF",
    },
    Enum: {
        Business: "01",
        Self: "02",
    }
};

export const ZoneStatus = {
    List: [
        { value: "01", label: "WMS_ZONE_FIELD_STATUS_COMPLETED" },
        { value: "02", label: "WMS_ZONE_FIELD_STATUS_IN_PROGRESS" },
        { value: "03", label: "WMS_ZONE_FIELD_STATUS_IN_PROGRESS_PARTS" },
    ],

    Map: {
        "01": "WMS_ZONE_FIELD_STATUS_COMPLETED",
        "02": "WMS_ZONE_FIELD_STATUS_IN_PROGRESS",
        "03": "WMS_ZONE_FIELD_STATUS_IN_PROGRESS_PARTS"
    },
    Enum: {
        Completed: "01",
        InProgress: "02",
        InProgressParts: "03"
    }
};

export const ZoneRadiusValue = {
    List: [
        { value: 1, label: "WMS_ZONE_FIELD_RADIUS_FIVE" },
        { value: 2, label: "WMS_ZONE_FIELD_RADIUS_TEN" },
        { value: 3, label: "WMS_ZONE_FIELD_RADIUS_FIFTEEN" },
        { value: 4, label: "WMS_ZONE_FIELD_RADIUS_TWENTY" }
    ],
    Map: {
        1: "WMS_ZONE_FIELD_RADIUS_FIVE",
        2: "WMS_ZONE_FIELD_RADIUS_TEN",
        3: "WMS_ZONE_FIELD_RADIUS_FIFTEEN",
        4: "WMS_ZONE_FIELD_RADIUS_TWENTY"
    },
    Enum: {
        five: 1,
        ten: 2,
        fifteen: 3,
        twenty: 4
    }
};

export const ZonePhotoTag = {
    List: [
        { value: "01", label: "WMS_ZONE_ROUTE_PHOTO_AERIAL_VIEW" },
        { value: "02", label: "WMS_ZONE_ROUTE_PHOTO_RENDERING_VIEW" },
        { value: "03", label: "WMS_ZONE_ROUTE_PHOTO_EXTERNAL_VIEW" },
        // {value: "04", label: "WMS_ZONE_ROUTE_PHOTO_EXTERNAL_PROFILE_VIEW"},
        { value: "05", label: "WMS_ZONE_ROUTE_PHOTO_INTERNAL_VIEW" },
        // {value: "06", label: "WMS_ZONE_ROUTE_PHOTO_INTERNAL_SHORT_AXIS_VIEW"},
        // {value: "07", label: "WMS_ZONE_ROUTE_PHOTO_INTERIOR_DIAGONAL_VIEW"},
        { value: "08", label: "WMS_ZONE_ROUTE_PHOTO_FIRE_PROTECTION_SYSTEM" },
        { value: "09", label: "WMS_ZONE_ROUTE_PHOTO_LIFT_PLATFORM" },
        { value: "10", label: "WMS_ZONE_ROUTE_PHOTO_FLOW_FIELD" },
        { value: "11", label: "WMS_ZONE_ROUTE_PHOTO_SUPPORTING_FACILITIES" },
        { value: "12", label: "WMS_ZONE_ROUTE_PHOTO_LIFT_UP_DOOR" },
        { value: "13", label: "WMS_ZONE_ROUTE_PHOTO_FORKLIFT_RAMP" },
        { value: "14", label: "WMS_ZONE_ROUTE_PHOTO_OFFICE" },
        { value: "15", label: "WMS_ZONE_ROUTE_PHOTO_CARGO_LIFT" },
        { value: "16", label: "WMS_ZONE_ROUTE_PHOTO_RAMP" }
    ],
    Map: {
        "01": "WMS_ZONE_ROUTE_PHOTO_AERIAL_VIEW",
        "02": "WMS_ZONE_ROUTE_PHOTO_RENDERING_VIEW",
        "03": "WMS_ZONE_ROUTE_PHOTO_EXTERNAL_VIEW",
        // "04": "WMS_ZONE_ROUTE_PHOTO_EXTERNAL_PROFILE_VIEW",
        "05": "WMS_ZONE_ROUTE_PHOTO_INTERNAL_VIEW",
        // "06": "WMS_ZONE_ROUTE_PHOTO_INTERNAL_SHORT_AXIS_VIEW",
        // "07": "WMS_ZONE_ROUTE_PHOTO_INTERIOR_DIAGONAL_VIEW",
        "08": "WMS_ZONE_ROUTE_PHOTO_FIRE_PROTECTION_SYSTEM",
        "09": "WMS_ZONE_ROUTE_PHOTO_LIFT_PLATFORM",
        "10": "WMS_ZONE_ROUTE_PHOTO_FLOW_FIELD",
        "11": "WMS_ZONE_ROUTE_PHOTO_SUPPORTING_FACILITIES",
        "12": "WMS_ZONE_ROUTE_PHOTO_LIFT_UP_DOOR",
        "13": "WMS_ZONE_ROUTE_PHOTO_FORKLIFT_RAMP",
        "14": "WMS_ZONE_ROUTE_PHOTO_OFFICE",
        "15": "WMS_ZONE_ROUTE_PHOTO_CARGO_LIFT",
        "16": "WMS_ZONE_ROUTE_PHOTO_RAMP",
        "20": "WMS_ZONE_ROUTE_LOCATION",
        "00": "WMS_ZONE_ROUTE_NO_IMAGE",

    },
    Enum: {
        aerial: "01",
        rendering: "02",
        extenalFacade: "03",
        extenalproFile: "04",
        internalLength: "05",
        internalShort: "06",
        interiorDiagonal: "07",
        fireProtectionSystem: "08",
        liftPlatform: "09",
        flowField: "10",
        supportingFacilities: "11",
        liftUpDoor: "12",
        forkliftRamp: "13",
        office: "14",
        cargoLift: "15",
        ramp: "16",
        noImage: "00",
        location: "20",
    }
};
//房源文件标签
export const ZoneFileTag = {
    List: [
        { value: "01", label: "WMS_ZONE_FILE_TAG_LAND_CERTIFICATE" },
        { value: "02", label: "WMS_ZONE_FILE_TAG_FIRE_CHECK_REPORT" },
        { value: "03", label: "WMS_ZONE_FILE_TAG_PROJECT_PLAN_CERTIFICATE" },
        { value: "04", label: "WMS_ZONE_FILE_TAG_PROJECT_WORK_CERTIFICATE" },
        { value: "05", label: "WMS_ZONE_FILE_TAG_PROJECT_END_REPORT" },
        { value: "06", label: "WMS_ZONE_FILE_TAG_HOUSE_CERTIFICATE" },
        { value: "07", label: "WMS_ZONE_FILE_TAG_ZONE_TOTAL_VIEW" },
        { value: "08", label: "WMS_ZONE_FILE_TAG_ZONE_HORIZONTAL_VERTICAL_VIEW" },
        { value: "09", label: "WMS_ZONE_FILE_TAG_CAD_DRAWINGS" },
        { value: "10", label: "WMS_ZONE_FILE_TAG_PROJECT_INTRODUCTION" },
        { value: "11", label: "WMS_ZONE_FILE_TAG_BUSINESS_LICENSE" },
        { value: "12", label: "WMS_ZONE_FILE_TAG_RENT_AREA_TABLE" },
    ],
    Map: {
        "01": "WMS_ZONE_FILE_TAG_LAND_CERTIFICATE",
        "02": "WMS_ZONE_FILE_TAG_FIRE_CHECK_REPORT",
        "03": "WMS_ZONE_FILE_TAG_PROJECT_PLAN_CERTIFICATE",
        "04": "WMS_ZONE_FILE_TAG_PROJECT_WORK_CERTIFICATE",
        "05": "WMS_ZONE_FILE_TAG_PROJECT_END_REPORT",
        "06": "WMS_ZONE_FILE_TAG_HOUSE_CERTIFICATE",
        "07": "WMS_ZONE_FILE_TAG_ZONE_TOTAL_VIEW",
        "08": "WMS_ZONE_FILE_TAG_ZONE_HORIZONTAL_VERTICAL_VIEW",
        "09": "WMS_ZONE_FILE_TAG_CAD_DRAWINGS",
        "10": "WMS_ZONE_FILE_TAG_PROJECT_INTRODUCTION",
        "11": "WMS_ZONE_FILE_TAG_BUSINESS_LICENSE",
        "12": "WMS_ZONE_FILE_TAG_RENT_AREA_TABLE",
    },
    Enum: {
        LAND_CERTIFICATE: "01",
        FIRE_CHECK_REPORT: "02",
        PROJECT_PLAN_CERTIFICATE: "03",
        PROJECT_WORK_CERTIFICATE: "04",
        PROJECT_END_REPORT: "05",
        HOUSE_CERTIFICATE: "06",
        ZONE_TOTAL_VIEW: "07",
        ZONE_HORIZONTAL_VERTICAL_VIEW: "08",
        CAD_DRAWINGS: "09",
        PROJECT_INTRODUCTION: "10",
        BUSINESS_LICENSE: "11",
        RENT_AREA_TABLE: "12",
        NONE: "00"
    }
};

export const BUILDING_TYPES = {
    List: [
        { value: "01", label: "单层库" },
        { value: "02", label: "多层坡道库" },
        { value: "03", label: "多层电梯库" },
        { value: "06", label: "多层电梯坡道库" },
        { value: "04", label: "平库" },
        { value: "05", label: "厂房" },

    ],
    Map: {
        "01": "单层库",
        "02": "多层坡道库",
        "03": "多层电梯库",
        "04": "平库",
        "05": "厂房",
        "06": "多层电梯坡道库"
    },
    Enum: {
        Single: "01",
        MultiRamp: "02",
        MultiElevator: "03",
        MultiFlat: "04",
        MultiWorkshop: "05",
        MultiElevatorRamp: "06"
    }
};

export const BUILDING_FIRE_FACILITIES = {
    List: [
        { value: "01", label: "WMS_BUILDING_FIELD_FIRE_FACILITIES_ESFR" },
        { value: "02", label: "WMS_BUILDING_FIELD_FIRE_FACILITIES_BUBBLE" },
        { value: "03", label: "WMS_BUILDING_FIELD_FIRE_FACILITIES_HYDRANT" },
    ],
    Map: {
        "01": "WMS_BUILDING_FIELD_FIRE_FACILITIES_ESFR",
        "02": "WMS_BUILDING_FIELD_FIRE_FACILITIES_BUBBLE",
        "03": "WMS_BUILDING_FIELD_FIRE_FACILITIES_HYDRANT",
    },
    Enum: {
        WSFR: "01",
        Bubble: "02",
        Hydrant: "03",
    }
};
export const BUILDING_FIRE_RATING = {
    List: [
        { value: "01", label: "丙-2类" },
        { value: "02", label: "丙类" },
        { value: "03", label: "丙-1类" },
        { value: "04", label: "丁类" },
        { value: "05", label: "乙类" },
        { value: "06", label: "甲类" },
    ],
    Map: {
        "01": "丙-2类",
        "02": "丙类",
        "03": "丙-1类",
        "04": "丁类",
        "05": "乙类",
        "06": "甲类",
    },
    Enum: {
        ClassC2: "01",
        ClassC: "02",
        ClassC1: "03",
        ClassD: "04",
        ClassB: "05",
        ClassA: "06",
    }
};
export const BUILDING_PLATFORM_FLAG = {
    List: [
        { value: "01", label: "有" },
        { value: "02", label: "无" },
    ],
    Map: {
        "01": "有",
        "02": "无",
    },
    Enum: {
        Has: "01",
        No: "02",
    }
};


export const BUILDING_PLATFORM_TYPE = {
    List: [
        { value: "01", label: "WMS_BUILDING_FIELD_PLATFORM_TYPE_INSIDE" },
        { value: "02", label: "WMS_BUILDING_FIELD_PLATFORM_TYPE_OUTSIDE" },
    ],
    Map: {
        "01": "WMS_BUILDING_FIELD_PLATFORM_TYPE_INSIDE",
        "02": "WMS_BUILDING_FIELD_PLATFORM_TYPE_OUTSIDE",
    },
    Enum: {
        Inside: "01",
        Outside: "02",
    }
};

export const BUILDING_SUPPORTING_FACILITY = {
    List: [
        { value: "01", label: "WMS_BUILDING_FIELD_SUPPORTING_FACILITY_DORMITORY" },
        { value: "02", label: "WMS_BUILDING_FIELD_SUPPORTING_FACILITY_CANTEEN" },
    ],
    Map: {
        "01": "WMS_BUILDING_FIELD_SUPPORTING_FACILITY_DORMITORY",
        "02": "WMS_BUILDING_FIELD_SUPPORTING_FACILITY_CANTEEN",
    },
    Enum: {
        Dormitory: "01",
        Canteen: "02",
    }
};
export const BUILDING_BUSINESS_TYPE = {
    List: [
        { value: "01", label: "普货仓" },
        { value: "02", label: "保税库" },
        { value: "03", label: "冷冻库" },
        { value: "04", label: "危险品库" },
        { value: "05", label: "空调/恒温库" },

    ],
    Map: {
        "01": "普货仓",
        "02": "保税库",
        "03": "冷冻库",
        "04": "危险品库",
        "05": "空调/恒温库"
    },
    Enum: {
        General: "01",
        Bonded: "02",
        Cold: "03",
        Dangerous: "04",
        AirCondition: "05"
    }
};

export const BUILDING_TAX_REQUIREMENTS = {
    List: [
        { value: "01", label: "WMS_BUILDING_FIELD_TAX_REQUIREMENTS_MANDATORY" },
        { value: "02", label: "WMS_BUILDING_FIELD_TAX_REQUIREMENTS_NO_MANDATORY" },
        { value: "03", label: "WMS_BUILDING_FIELD_TAX_REQUIREMENTS_UNKNOWN" },
    ],
    Map: {
        "01": "WMS_BUILDING_FIELD_TAX_REQUIREMENTS_MANDATORY",
        "02": "WMS_BUILDING_FIELD_TAX_REQUIREMENTS_NO_MANDATORY",
        "03": "WMS_BUILDING_FIELD_TAX_REQUIREMENTS_UNKNOWN",
    },
    Enum: {
        Mandatory: "01",
        NoMandatory: "02",
        Unknown: "03",
    }
};


export const BUILDING_UNLOADING_TYPE = {
    List: [
        { value: "01", label: "单面" },
        { value: "02", label: "双面" },
        { value: "03", label: "多面" },
    ],
    Map: {
        "01": "单面",
        "02": "双面",
        "03": "多面",
    },
    Enum: {
        Single: "01",
        Double: "02",
        Multi: "03",
    }
};

export const BUILDING_COOPERATION_TYPE = {
    List: [
        { value: "01", label: "WMS_BUILDING_FIELD_COOPERATION_TYPE_PURE_WAREHOUSE" },
        { value: "02", label: "WMS_BUILDING_FIELD_COOPERATION_TYPE_WAREHOUSE_MANAGER" },
        { value: "03", label: "WMS_BUILDING_FIELD_COOPERATION_TYPE_OUTSOURCE" },
    ],
    Map: {
        "01": "WMS_BUILDING_FIELD_COOPERATION_TYPE_PURE_WAREHOUSE",
        "02": "WMS_BUILDING_FIELD_COOPERATION_TYPE_WAREHOUSE_MANAGER",
        "03": "WMS_BUILDING_FIELD_COOPERATION_TYPE_OUTSOURCE",
    },
    Enum: {
        PureWarehouse: "01",
        WarehouseManager: "02",
        OutSource: "03",
    }
};

export const RentUnit = {
    List: [
        { value: "01", label: "WMS_ZONE_FIELD_RENT_UNIT_DAY" },
        { value: "02", label: "WMS_ZONE_FIELD_RENT_UNIT_MONTH" },
        { value: "03", label: "WMS_ZONE_FIELD_RENT_UNIT_YEAR" },
    ],
    Map: {
        "01": "WMS_ZONE_FIELD_RENT_UNIT_DAY",
        "02": "WMS_ZONE_FIELD_RENT_UNIT_MONTH",
        "03": "WMS_ZONE_FIELD_RENT_UNIT_YEAR"
    },
    Enum: {
        Day: "01",
        Month: "02",
        Year: "03"
    }
};

export const LandOwnershipList = {
    List: [
        { value: "01", label: "WMS_ZONE_FIELD_STATE_OWNED_LAND" },
        { value: "02", label: "WMS_ZONE_FIELD_COLLECTIVE_LAND" },
        { value: "03", label: "WMS_ZONE_FIELD_PRODUCTION_LAND" },
        { value: "04", label: "WMS_ZONE_FIELD_LAND_AREA_UNKNOWN" }
    ],
    Map: {
        "01": "WMS_ZONE_FIELD_STATE_OWNED_LAND",
        "02": "WMS_ZONE_FIELD_COLLECTIVE_LAND",
        "03": "WMS_ZONE_FIELD_PRODUCTION_LAND",
        "04": "WMS_ZONE_FIELD_LAND_AREA_UNKNOWN"
    },
    Enum: {
        stateOwnedLand: "01",
        collectiveLand: "02",
        productionLand: "03",
        unknown: "04"
    }
};

export const LandUsList = {
    List: [
        { value: "01", label: "WMS_ZONE_FIELD_INDUSTRIAL_LAND" },
        { value: "02", label: "WMS_ZONE_FIELD_WAREHOUSE_LAND" },
        { value: "03", label: "WMS_ZONE_FIELD_LAND_AREA_UNKNOWN" }
    ],
    Map: {
        "01": "WMS_ZONE_FIELD_INDUSTRIAL_LAND",
        "02": "WMS_ZONE_FIELD_WAREHOUSE_LAND",
        "03": "WMS_ZONE_FIELD_LAND_AREA_UNKNOWN"
    },
    Enum: {
        industrialLand: "01",
        warehouseLand: "02",
        unknown: "03"
    }
};

export const propertyLevel = {
    List: [
        { value: "01", label: "WMS_ZONE_FIELD_CLASS_A_WAREHOUSE" },
        { value: "02", label: "WMS_ZONE_FIELD_CLASS_B_WAREHOUSE" },
        { value: "03", label: "WMS_ZONE_FIELD_CLASS_C_WORKSHOP" }
    ],
    Map: {
        "01": "WMS_ZONE_FIELD_CLASS_A_WAREHOUSE",
        "02": "WMS_ZONE_FIELD_CLASS_B_WAREHOUSE",
        "03": "WMS_ZONE_FIELD_CLASS_C_WORKSHOP"
    },
    Enum: {
        classA: "01",
        classB: "02",
        classC: "03"
    }
};

export const TenementType = {
    List: [
        { value: "01", label: "WMS_LESSEE_COMPANY_COMMERCE" },
        { value: "02", label: "WMS_LESSEE_COMPANY_PL" },
        { value: "03", label: "WMS_LESSEE_COMPANY_MANUFACTURING" },
        { value: "04", label: "WMS_LESSEE_COMPANY_RETAIL" },
        { value: "05", label: "WMS_LESSEE_COMPANY_EXPRESS" },
        { value: "06", label: "WMS_LESSEE_COMPANY_HEAD_LESSEE" },
        { value: "07", label: "WMS_LESSEE_COMPANY_COLD_CHAIN" },

    ],
    Map: {
        "01": "WMS_LESSEE_COMPANY_COMMERCE",
        "02": "WMS_LESSEE_COMPANY_PL",
        "03": "WMS_LESSEE_COMPANY_MANUFACTURING",
        "04": "WMS_LESSEE_COMPANY_RETAIL",
        "05": "WMS_LESSEE_COMPANY_EXPRESS",
        "06": "WMS_LESSEE_COMPANY_HEAD_LESSEE",
        "07": "WMS_LESSEE_COMPANY_COLD_CHAIN",
    },
    Enum: {
        commerce: "01",
        pl: "02",
        manufacturing: "03",
        retail: "04",
        express: "05",
        headLessee: "06",
        coldChain: "07"
    }
};

export const LeaseStatusType = {
    List: [
        { value: "01", label: "WMS_LEASE_FIELD_HISTORY" },
        { value: "02", label: "WMS_LEASE_FIELD_CURRENT" },
    ],
    Map: {
        "01": "WMS_LEASE_FIELD_HISTORY",
        "02": "WMS_LEASE_FIELD_CURRENT",
    },
    Enum: {
        history: "01",
        current: "02",
    }
};

//货物类型
export const TerminalCompanyType = {
    List: [
        { value: "01", label: "WMS_LESSEE_TERMINAL_GOODS_TYPE_DAILY_CONSUMABLES" },
        { value: "05", label: "WMS_LESSEE_TERMINAL_GOODS_TYPE_CLOTHING" },
        { value: "12", label: "WMS_LESSEE_TERMINAL_GOODS_TYPE_COSMETICS" },
        { value: "03", label: "WMS_LESSEE_TERMINAL_GOODS_TYPE_FOOD" },
        { value: "09", label: "WMS_LESSEE_TERMINAL_GOODS_TYPE_FRESH_VEGETABLE_FRUIT" },
        { value: "02", label: "WMS_LESSEE_TERMINAL_GOODS_TYPE_MEDICAL_INSTRUMENTS" },
        { value: "14", label: "WMS_LESSEE_TERMINAL_GOODS_TYPE_FURNITURE" },
        { value: "06", label: "WMS_LESSEE_TERMINAL_GOODS_TYPE_LARGE_HOUSEHOLD_APPLIANCES" },
        { value: "07", label: "WMS_LESSEE_TERMINAL_GOODS_TYPE_SMALL_HOME_APPLIANCES" },
        { value: "04", label: "WMS_LESSEE_TERMINAL_GOODS_TYPE_AUTO_PARTS" },
        { value: "10", label: "WMS_LESSEE_TERMINAL_GOODS_TYPE_ELECTRONIC_COMPONENTS" },
        { value: "11", label: "WMS_LESSEE_TERMINAL_GOODS_TYPE_INDUSTRIAL_PRODUCTS" },
        { value: "18", label: "WMS_LESSEE_TERMINAL_GOODS_TYPE_RUBBER" },
        { value: "08", label: "WMS_LESSEE_TERMINAL_GOODS_TYPE_MECHANICAL_EQUIPMENT" },
        { value: "13", label: "WMS_LESSEE_TERMINAL_GOODS_TYPE_STEEL" },
        { value: "15", label: "WMS_LESSEE_TERMINAL_GOODS_TYPE_LIQUOR" },
        { value: "16", label: "WMS_LESSEE_TERMINAL_GOODS_TYPE_LUBRICATING_OIL_PAINT" },
        { value: "17", label: "WMS_LESSEE_TERMINAL_GOODS_TYPE_DANGEROUS_GOODS" },
    ],
    Map: {
        "01": "WMS_LESSEE_TERMINAL_GOODS_TYPE_DAILY_CONSUMABLES",
        "02": "WMS_LESSEE_TERMINAL_GOODS_TYPE_MEDICAL_INSTRUMENTS",
        "03": "WMS_LESSEE_TERMINAL_GOODS_TYPE_FOOD",
        "04": "WMS_LESSEE_TERMINAL_GOODS_TYPE_AUTO_PARTS",
        "05": "WMS_LESSEE_TERMINAL_GOODS_TYPE_CLOTHING",
        "06": "WMS_LESSEE_TERMINAL_GOODS_TYPE_LARGE_HOUSEHOLD_APPLIANCES",
        "07": "WMS_LESSEE_TERMINAL_GOODS_TYPE_SMALL_HOME_APPLIANCES",
        "08": "WMS_LESSEE_TERMINAL_GOODS_TYPE_MECHANICAL_EQUIPMENT",
        "09": "WMS_LESSEE_TERMINAL_GOODS_TYPE_FRESH_VEGETABLE_FRUIT",
        "10": "WMS_LESSEE_TERMINAL_GOODS_TYPE_ELECTRONIC_COMPONENTS",
        "11": "WMS_LESSEE_TERMINAL_GOODS_TYPE_INDUSTRIAL_PRODUCTS",
        "12": "WMS_LESSEE_TERMINAL_GOODS_TYPE_COSMETICS",
        "13": "WMS_LESSEE_TERMINAL_GOODS_TYPE_STEEL",
        "14": "WMS_LESSEE_TERMINAL_GOODS_TYPE_FURNITURE",
        "15": "WMS_LESSEE_TERMINAL_GOODS_TYPE_LIQUOR",
        "16": "WMS_LESSEE_TERMINAL_GOODS_TYPE_LUBRICATING_OIL_PAINT",
        "17": "WMS_LESSEE_TERMINAL_GOODS_TYPE_DANGEROUS_GOODS",
        "18": "WMS_LESSEE_TERMINAL_GOODS_TYPE_RUBBER",
    },
    Enum: {
        DailyConsumables: "01",
        MedicalInstruments: "02",
        Food: "03",
        AutoParts: "04",
        Clothing: "05",
        LargeHouseholdAppliances: "06",
        SmallHomeAppliances: "07",
        MechanicalEquipment: "08",
        FreshVegetableFruit: "09",
        ElectronicComponents: "10",
        IndustrialProducts: "11",
        Cosmetics: "12",
        Steel: "13",
        furniture: "14",
        liquor: "15",
        LubricatingOilPaint: "16",
        DangerousGoods: "17",
        Rubber: "18",
    }
};


export const TenementCategory = {
    List: [
        { value: "01", label: "WMS_COMPANY_FIELD_HIGH_FREQUENCY_TRUE" },
        { value: "02", label: "WMS_COMPANY_FIELD_HIGH_FREQUENCY_FALSE" }
    ],
    Map: {
        "01": "WMS_COMPANY_FIELD_HIGH_FREQUENCY_TRUE",
        "02": "WMS_COMPANY_FIELD_HIGH_FREQUENCY_FALSE"
    },
    Enum: {
        brand: "01",
        tenant: "02",
    }
};

export const BRAND_CLASSIFY =
{
    List: [
        { value: "01", label: "WMS_COMPANY_FIELD_HIGH_FREQUENCY_TRUE" },
        { value: "02", label: "WMS_COMPANY_FIELD_HIGH_FREQUENCY_FALSE" }
    ],
    Map: {
        "01": "WMS_COMPANY_FIELD_HIGH_FREQUENCY_TRUE",
        "02": "WMS_COMPANY_FIELD_HIGH_FREQUENCY_FALSE"
    },
    Enum: {
        lessor: "01",
        tenant: "02",
    }
};

export const TAGS_TYPE =
{
    List: [
        { value: "01", label: "接受短租" },
        { value: "02", label: "独门独院" },
        { value: "03", label: "电量充足" },
        // {value: "04", label: "快递分拨"},
        { value: "05", label: "可改冷库" },
        { value: "06", label: "强制注册" },
        // {value: "07", label: "限时特价"},
        // {value: "08", label: "7日上新"},
        // {value: "09", label: "最新成交"}
        { value: "10", label: "绿色建筑" }

    ],
    Map: {
        "01": { label: "接受短租", colorStyle: { color: '#FFF', backgroundColor: '#2C96F3' } },
        "02": { label: "独门独院", colorStyle: { color: '#FFF', backgroundColor: '#2C96F3' } },
        "03": { label: "电量充足", colorStyle: { color: '#FFF', backgroundColor: '#2C96F3' } },
        // "04": {label: "快递分拨", colorStyle: {color: '#FFF', backgroundColor: '#2C96F3'}},
        "05": { label: "可改冷库", colorStyle: { color: '#FFF', backgroundColor: '#2C96F3' } },

        "06": { label: "强制注册", colorStyle: { color: '#FFF', backgroundColor: '#2C96F3' } },
        "10": { label: "绿色建筑", colorStyle: { color: '#FFF', backgroundColor: '#2C96F3' } },
        "B1": { label: "高标库", colorStyle: { color: '#FFF', backgroundColor: '#2C96F3' } },
        "B2": { label: "工业厂房", colorStyle: { color: '#FFF', backgroundColor: '#2C96F3' } },
        "A1": { label: "双面卸货", colorStyle: { color: '#FFF', backgroundColor: '#2C96F3' } },
        "A2": { label: "多面卸货", colorStyle: { color: '#FFF', backgroundColor: '#2C96F3' } },
        "A3": { label: "外置月台", colorStyle: { color: '#FFF', backgroundColor: '#2C96F3' } }
        // "07": {label: "限时特价", colorStyle: {color: '#FFF', backgroundColor: '#2C96F3'}},
        // "08": {label: "7日上新", colorStyle: {color: '#FFF', backgroundColor: '#2C96F3'}},
        // "09": {label: "最新成交", colorStyle: {color: '#FFF', backgroundColor: '#2C96F3'}}
    }, Enum: {
        acceptRent: "01",
        privateHouse: "02",
        plentyPower: "03",
        expressDistribution: "04",
        storage: "05",
        compulsoryRegistration: "06",

        DuplicateUnloading: 'A1',
        MultipleUnloading: 'A2',
        PlatformOutside: 'A3',
        Grade1: 'B1',
        Grade2: 'B2',
        // limitedTimeSpecial: "07",
        // New7th: "08",
        // latestTransaction: "09"
    },
};

export const RentTaxType = {
    List: [
        { value: "01", label: "WMS_ZONE_FIELD_RENT_TAX_TYPE_TAX_INCLUDE" },
        { value: "02", label: "WMS_ZONE_FIELD_RENT_TAX_TYPE_TAX_FREE" },
    ],
    Map: {
        "01": "WMS_ZONE_FIELD_RENT_TAX_TYPE_TAX_INCLUDE",
        "02": "WMS_ZONE_FIELD_RENT_TAX_TYPE_TAX_FREE",
    },
    Enum: {
        Include: "01",
        Free: "02",
    }
};
export const RentTaxPropertyType = {
    List: [
        { value: "01", label: "WMS_ZONE_FIELD_RENT_TAX_PROPERTY_TYPE_TAX_INCLUDE" },
        { value: "02", label: "WMS_ZONE_FIELD_RENT_TAX_PROPERTY_TYPE_TAX_FREE" },
    ],
    Map: {
        "01": "WMS_ZONE_FIELD_RENT_TAX_PROPERTY_TYPE_TAX_INCLUDE",
        "02": "WMS_ZONE_FIELD_RENT_TAX_PROPERTY_TYPE_TAX_FREE",
    },
    Enum: {
        Include: "01",
        Free: "02",
    }
};
export const RentPropertyType = {
    List: [
        { value: "01", label: "WMS_ZONE_FIELD_RENT_PROPERTY_TYPE_INCLUDE" },
        { value: "02", label: "WMS_ZONE_FIELD_RENT_PROPERTY_TYPE_FREE" },
    ],
    Map: {
        "01": "WMS_ZONE_FIELD_RENT_PROPERTY_TYPE_INCLUDE",
        "02": "WMS_ZONE_FIELD_RENT_PROPERTY_TYPE_FREE",
    },
    Enum: {
        Include: "01",
        Free: "02",
    }
};

export const RentPropertySplitType = {
    List: [
        { value: "01", label: "WMS_ZONE_FIELD_RENT_PROPERTY_SPLIT_TYPE_ADJUST" },
        { value: "02", label: "WMS_ZONE_FIELD_RENT_PROPERTY_SPLIT_TYPE_NO_ADJUST" },
        { value: "03", label: "WMS_ZONE_FIELD_RENT_PROPERTY_SPLIT_TYPE_UNKNOWN" },
    ],
    Map: {
        "01": "WMS_ZONE_FIELD_RENT_PROPERTY_SPLIT_TYPE_ADJUST",
        "02": "WMS_ZONE_FIELD_RENT_PROPERTY_SPLIT_TYPE_NO_ADJUST",
        "03": "WMS_ZONE_FIELD_RENT_PROPERTY_SPLIT_TYPE_UNKNOWN",
    },
    Enum: {
        Adjust: "01",
        NoAdjust: "02",
        Unknown: "03",
    }
};
export const RentPropertySplitType2 = {
    List: [
        { value: "01", label: "WMS_ZONE_FIELD_RENT_PROPERTY_SPLIT_TYPE_SPLIT" },
        { value: "02", label: "WMS_ZONE_FIELD_RENT_PROPERTY_SPLIT_TYPE_NO_SPLIT" },
    ],
    Map: {
        "01": "WMS_ZONE_FIELD_RENT_PROPERTY_SPLIT_TYPE_SPLIT",
        "02": "WMS_ZONE_FIELD_RENT_PROPERTY_SPLIT_TYPE_NO_SPLIT",

    },
    Enum: {
        Split: "01",
        NoSplit: "02",

    }
};

export const FollowType = {
    List: [
        { value: "01", label: "WMS_FOLLOWUP_FIELD_FOLLOW_TYPE_PASSIVE" },
        { value: "02", label: "WMS_FOLLOWUP_FIELD_FOLLOW_TYPE_ACTIVE" },
    ],
    Map: {
        "01": "WMS_FOLLOWUP_FIELD_FOLLOW_TYPE_PASSIVE",
        "02": "WMS_FOLLOWUP_FIELD_FOLLOW_TYPE_ACTIVE",
    },
    Enum: {
        Passive: "01",
        Active: "02"
    }
};


export const VIEWPORT_FLAG = {
    CHANGE: "01",
    NO_CHANGE: "02",
}

export const MAP_SCALE_DATA = {
    19: { zoom: 19, length: 20, Pixels: 48 },
    18: { zoom: 18, length: 50, Pixels: 61 },
    17: { zoom: 17, length: 100, Pixels: 61 },
    16: { zoom: 16, length: 200, Pixels: 61 },
    15: { zoom: 15, length: 500, Pixels: 78 },
    14: { zoom: 14, length: 1000, Pixels: 78 },
    13: { zoom: 13, length: 2000, Pixels: 78 },
    12: { zoom: 12, length: 5000, Pixels: 99 },
    11: { zoom: 11, length: 10000, Pixels: 99 },
    10: { zoom: 10, length: 20000, Pixels: 99 },
    9: { zoom: 9, length: 25000, Pixels: 59 },
    8: { zoom: 8, length: 50000, Pixels: 59 },
    7: { zoom: 7, length: 100000, Pixels: 59 },
    6: { zoom: 6, length: 200000, Pixels: 59 },
    5: { zoom: 5, length: 500000, Pixels: 76 },
    4: { zoom: 4, length: 1000000, Pixels: 76 },
    3: { zoom: 3, length: 2000000, Pixels: 75 }
}
export const MAP_SEARCH_RANGE_DATA = {
    MAP: {
        "00": {
            code: "00",
            label: "附近 5 公里",
            value: 5,
        },
        "01": {
            code: "01",
            label: "附近 10 公里",
            value: 10,
        },
        "02": {
            code: "02",
            label: "附近 15 公里",
            value: 15,
        },
        "03": {
            code: "03",
            label: "附近 20 公里",
            value: 20,
        },
        "04": {
            code: "04",
            label: "附近 30 公里",
            value: 30,
        }
        ,
        "05": {
            code: "05",
            label: "附近 50 公里",
            value: 50,
        }
        ,
        "06": {
            code: "06",
            label: "自定义",
            value: 5,
        }
    },
    List: ["00", "01", "02", "03", "04", "05", "06"],
    Enum: {
        RANGE_5: "00",
        RANGE_10: "01",
        RANGE_15: "02",
        RANGE_20: "03",
        RANGE_30: "04",
        RANGE_50: "05",
        RANGE_CUSTOM: "06"
    }
};

export const TraderType = {
    List: [
        { value: "01", label: "WMS_LEASE_FIELD_TRADER_TYPE_EMPLOYEE" },
        { value: "02", label: "WMS_LEASE_FIELD_TRADER_TYPE_OWNER" },
        { value: "03", label: "WMS_LEASE_FIELD_TRADER_TYPE_THIRD" },
    ],
    Map: {
        "01": "WMS_LEASE_FIELD_TRADER_TYPE_EMPLOYEE",
        "02": "WMS_LEASE_FIELD_TRADER_TYPE_OWNER",
        "03": "WMS_LEASE_FIELD_TRADER_TYPE_THIRD",
    },
    Enum: {
        Employee: "01",
        Owner: "02",
        Third: "03"
    }
};

export const LocationType = {
    List: [
        { value: "01", label: "WMS_ZONE_TITLE_SPECIFICATION" },
        { value: "02", label: "WMS_ZONE_TITLE_BUILDINGS" }
    ],
    Map: {
        "01": "WMS_ZONE_TITLE_SPECIFICATION",
        "02": "WMS_ZONE_TITLE_BUILDINGS"
    },
    Enum: {
        Specification: "01",
        Buildings: "02"
    }
};

export const LocationAreaType = {
    List: [
        { value: "01", label: "WMS_ZONE_FIELD_LOCATION_LOAD_AREA" },
        { value: "02", label: "WMS_ZONE_FIELD_LOCATION_BUILDING_AREA" }
    ],
    Map: {
        "01": "WMS_ZONE_FIELD_LOCATION_LOAD_AREA",
        "02": "WMS_ZONE_FIELD_LOCATION_BUILDING_AREA"
    },
    Enum: {
        LoadArea: "01",
        BuildingArea: "02"
    }
};

export const ContactClassify = {
    Enum: {
        Lessor: "01",
        Lessee: "02",
        Main: "99"
    }
};

export const ContactsOperationTypes = {
    Enum: {
        Default: '00',
        Zone: "01",
        Opportunity: "02",
        Research: "03"
    }
};
export const ProposalClassifyType = {

    List: [
        { value: "01", label: "WMS_PROPOSAL_CLASSIFY_INFORMATION" },
        { value: "02", label: "WMS_PROPOSAL_CLASSIFY_BUSINESS" },
        { value: "03", label: "WMS_PROPOSAL_CLASSIFY_OTHER" },
        { value: "04", label: "WMS_PROPOSAL_CLASSIFY_SPEC" },
    ],
    Map: {
        "01": "WMS_PROPOSAL_CLASSIFY_INFORMATION",
        "02": "WMS_PROPOSAL_CLASSIFY_BUSINESS",
        "03": "WMS_PROPOSAL_CLASSIFY_OTHER",
        "04": "WMS_PROPOSAL_CLASSIFY_SPEC",
    },
    Enum: {
        Information: "01",
        Business: "02",
        Other: "03",
        Spec: "04"
    }
};

export const ZONE_LOCATION_TOOL_TYPE = {
    Enum: {
        Default: '00',
        Point: "01",
        ZoneArea: "02",
        BuildArea: "03"
    }
};

export const OpportunityBusinessPPTTitleType = {
    List: [
        { value: "01", label: "WMS_BUSINESS_OPPORTUNITY_TITLE_BUSINESS_PROFILE" },
        { value: "02", label: "WMS_BUSINESS_OPPORTUNITY_TITLE_PLANNING_REQUIREMENTS" },
    ],
    Map: {
        "01": "WMS_BUSINESS_OPPORTUNITY_TITLE_BUSINESS_PROFILE",
        "02": "WMS_BUSINESS_OPPORTUNITY_TITLE_PLANNING_REQUIREMENTS",
    },
    Enum: {

        profile: "01",
        requirements: "02",
    }
};

export const OpportunityBusinessType = {
    List: [
        { value: "01", label: "WMS_BUSINESS_OPPORTUNITY_FIELD_BUSINESS_TYPE_BIDDING" },
        { value: "02", label: "WMS_BUSINESS_OPPORTUNITY_FIELD_BUSINESS_TYPE_SELF" },
    ],
    Map: {
        "01": "WMS_BUSINESS_OPPORTUNITY_FIELD_BUSINESS_TYPE_BIDDING",
        "02": "WMS_BUSINESS_OPPORTUNITY_FIELD_BUSINESS_TYPE_SELF",
    },
    Enum: {

        Bidding: "01",
        Self: "02",
    }
};

export const OpportunityBusinessScaleType = {
    List: [
        { value: "", label: "WMS_BUSINESS_OPPORTUNITY_FIELD_UNLIMITED" },
        { value: "01", label: "WMS_BUSINESS_OPPORTUNITY_FIELD_GRADE_1" },
        { value: "02", label: "WMS_BUSINESS_OPPORTUNITY_FIELD_GRADE_2" },
        { value: "03", label: "WMS_BUSINESS_OPPORTUNITY_FIELD_GRADE_3" },
    ],
    Map: {
        "": "WMS_BUSINESS_OPPORTUNITY_FIELD_UNLIMITED",
        "01": "WMS_BUSINESS_OPPORTUNITY_FIELD_GRADE_1",
        "02": "WMS_BUSINESS_OPPORTUNITY_FIELD_GRADE_2",
        "03": "WMS_BUSINESS_OPPORTUNITY_FIELD_GRADE_3",
    },
    Enum: {
        Unlimited: "",
        A: "01",
        B: "02",
        C: "03",
    }
};

export const OpportunityBusinessFollowUpType = {
    List: [
        { value: "", label: "WMS_BUSINESS_OPPORTUNITY_FIELD_UNLIMITED" },
        { value: "1", label: "WMS_BUSINESS_OPPORTUNITY_FIELD_MAIN_FOLLOW_UP" },
        { value: "0", label: "WMS_BUSINESS_OPPORTUNITY_FIELD_ASSIST_FOLLOW_UP" },
    ],
    Map: {
        "": "WMS_BUSINESS_OPPORTUNITY_FIELD_UNLIMITED",
        "1": "WMS_BUSINESS_OPPORTUNITY_FIELD_MAIN_FOLLOW_UP",
        "0": "WMS_BUSINESS_OPPORTUNITY_FIELD_ASSIST_FOLLOW_UP",
    },
    Enum: {

        Unlimited: "",
        MainFollowUp: "1",
        AssistFollowUp: "0",
    }
};

export const OpportunityRequirementType = {
    List: [
        { value: "01", label: "WMS_BUSINESS_OPPORTUNITY_FIELD_REQUIREMENT_TYPE_NEW" },
        { value: "02", label: "WMS_BUSINESS_OPPORTUNITY_FIELD_REQUIREMENT_TYPE_MOVE" },
        { value: "03", label: "WMS_BUSINESS_OPPORTUNITY_FIELD_REQUIREMENT_TYPE_RESEARCH" },

    ],
    Map: {
        "00": "COMMON_FIELD_VALUE_UNKNOWN",
        "01": "WMS_BUSINESS_OPPORTUNITY_FIELD_REQUIREMENT_TYPE_NEW",
        "02": "WMS_BUSINESS_OPPORTUNITY_FIELD_REQUIREMENT_TYPE_MOVE",
        "03": "WMS_BUSINESS_OPPORTUNITY_FIELD_REQUIREMENT_TYPE_RESEARCH",
    },
    Enum: {
        Unknown: "00",
        NEW: "01",
        MOVE: "02",
        RESEARCH: "03",
    }
};
export const OpportunityMainUsage = {
    List: [
        { value: "01", label: "WMS_BUSINESS_OPPORTUNITY_FIELD_MAIN_USAGE_WAREHOUSE" },
        { value: "02", label: "WMS_BUSINESS_OPPORTUNITY_FIELD_MAIN_USAGE_TRANSFER" },
        { value: "03", label: "WMS_BUSINESS_OPPORTUNITY_FIELD_MAIN_USAGE_MANUFACTURE" },

    ],
    Map: {
        "01": "WMS_BUSINESS_OPPORTUNITY_FIELD_MAIN_USAGE_WAREHOUSE",
        "02": "WMS_BUSINESS_OPPORTUNITY_FIELD_MAIN_USAGE_TRANSFER",
        "03": "WMS_BUSINESS_OPPORTUNITY_FIELD_MAIN_USAGE_MANUFACTURE",
    },
    Enum: {
        WAREHOUSE: "01",
        TRANSFER: "02",
        MANUFACTURE: "03",
    }
};
export const OpportunityRequirementTags = {
    List: [
        { value: "01", label: "WMS_BUSINESS_OPPORTUNITY_FIELD_REQUIREMENT_TYPE_NEW" },
        { value: "02", label: "WMS_BUSINESS_OPPORTUNITY_FIELD_REQUIREMENT_TYPE_MOVE" },
        { value: "03", label: "WMS_BUSINESS_OPPORTUNITY_FIELD_REQUIREMENT_TYPE_RESEARCH" },

    ],
    Map: {
        "01": "WMS_BUSINESS_OPPORTUNITY_FIELD_REQUIREMENT_TYPE_NEW",
        "02": "WMS_BUSINESS_OPPORTUNITY_FIELD_REQUIREMENT_TYPE_MOVE",
        "03": "WMS_BUSINESS_OPPORTUNITY_FIELD_REQUIREMENT_TYPE_RESEARCH",
    },
    Enum: {
        NEW: "01",
        MOVE: "02",
        RESEARCH: "03",
    }
};

export const OpportunitySpecFloor = {
    List: [
        { value: "01", label: "WMS_BUSINESS_OPPORTUNITY_FIELD_SPEC_FLOOR_ONLY_SINGLE" },
        { value: "02", label: "WMS_BUSINESS_OPPORTUNITY_FIELD_SPEC_FLOOR_ALL" },
        { value: "03", label: "WMS_BUSINESS_OPPORTUNITY_FIELD_SPEC_FLOOR_GARAGE" },

    ],
    Map: {
        "01": "WMS_BUSINESS_OPPORTUNITY_FIELD_SPEC_FLOOR_ONLY_SINGLE",
        "02": "WMS_BUSINESS_OPPORTUNITY_FIELD_SPEC_FLOOR_ALL",
        "03": "WMS_BUSINESS_OPPORTUNITY_FIELD_SPEC_FLOOR_GARAGE",
    },
    Enum: {
        ONLY_SINGLE: "01",
        ALL: "02",
        GARAGE: "03",
    }
};
export const OpportunitySpecFireFacilities = {
    List: [
        { value: "01", label: "COMMON_FIELD_VALUE_NO_LIMIT" },
        { value: "02", label: "WMS_BUSINESS_OPPORTUNITY_FIELD_SPEC_FIRE_FACILITIES_SPRAY" },

    ],
    Map: {
        "01": "COMMON_FIELD_VALUE_NO_LIMIT",
        "02": "WMS_BUSINESS_OPPORTUNITY_FIELD_SPEC_FIRE_FACILITIES_SPRAY",
    },
    Enum: {
        ON_LIMIT: "01",
        SPRAY: "02",

    }
};
export const OpportunitySpecPlatform = {
    List: [
        { value: "01", label: "COMMON_FIELD_VALUE_NO_LIMIT" },
        { value: "02", label: "WMS_BUSINESS_OPPORTUNITY_FIELD_SPEC_PLATFORM_HAS" },
        { value: "03", label: "WMS_BUSINESS_OPPORTUNITY_FIELD_SPEC_PLATFORM_NO" },

    ],
    Map: {
        "01": "COMMON_FIELD_VALUE_NO_LIMIT",
        "02": "WMS_BUSINESS_OPPORTUNITY_FIELD_SPEC_PLATFORM_HAS",
        "03": "WMS_BUSINESS_OPPORTUNITY_FIELD_SPEC_PLATFORM_NO",

    },
    Enum: {
        ON_LIMIT: "01",
        HAS: "02",
        NO: "03",

    }
};
export const OpportunitySpecSupportingFacility = {
    List: [
        { value: "01", label: "COMMON_FIELD_VALUE_NO_LIMIT" },
        { value: "02", label: "WMS_BUSINESS_OPPORTUNITY_FIELD_SPEC_SUPPORTING_FACILITY_DORMITORY" },

    ],
    Map: {
        "01": "COMMON_FIELD_VALUE_NO_LIMIT",
        "02": "WMS_BUSINESS_OPPORTUNITY_FIELD_SPEC_SUPPORTING_FACILITY_DORMITORY",

    },
    Enum: {
        ON_LIMIT: "01",
        DORMITORY: "02",
    }
};

export const OpportunityStatus = {
    List: [
        { value: "01", label: "WMS_BUSINESS_OPPORTUNITY_FIELD_STATUS_NEW" },
        { value: "02", label: "WMS_BUSINESS_OPPORTUNITY_FIELD_STATUS_IN_PROPOSAL" },
        { value: "03", label: "WMS_BUSINESS_OPPORTUNITY_FIELD_STATUS_IN_COMMUNICATE" },
        { value: "04", label: "WMS_BUSINESS_OPPORTUNITY_FIELD_STATUS_IN_SCHEDULE" },
        { value: "05", label: "WMS_BUSINESS_OPPORTUNITY_FIELD_STATUS_IN_INTENTION" },
        { value: "06", label: "WMS_BUSINESS_OPPORTUNITY_FIELD_STATUS_IN_CONTRACT" },
        { value: "07", label: "WMS_BUSINESS_OPPORTUNITY_FIELD_STATUS_IN_RECEIVE" },
        { value: "08", label: "WMS_BUSINESS_OPPORTUNITY_FIELD_STATUS_COMPLETED" },
        { value: "09", label: "WMS_BUSINESS_OPPORTUNITY_FIELD_STATUS_POSTPONED" },
        { value: "10", label: "WMS_BUSINESS_OPPORTUNITY_FIELD_STATUS_LOST" }

    ],
    Map: {
        "01": "WMS_BUSINESS_OPPORTUNITY_FIELD_STATUS_NEW",
        "02": "WMS_BUSINESS_OPPORTUNITY_FIELD_STATUS_IN_PROPOSAL",
        "03": "WMS_BUSINESS_OPPORTUNITY_FIELD_STATUS_IN_COMMUNICATE",
        "04": "WMS_BUSINESS_OPPORTUNITY_FIELD_STATUS_IN_SCHEDULE",
        "05": "WMS_BUSINESS_OPPORTUNITY_FIELD_STATUS_IN_INTENTION",
        "06": "WMS_BUSINESS_OPPORTUNITY_FIELD_STATUS_IN_CONTRACT",
        "07": "WMS_BUSINESS_OPPORTUNITY_FIELD_STATUS_IN_RECEIVE",
        "08": "WMS_BUSINESS_OPPORTUNITY_FIELD_STATUS_COMPLETED",
        "09": "WMS_BUSINESS_OPPORTUNITY_FIELD_STATUS_POSTPONED",
        "10": "WMS_BUSINESS_OPPORTUNITY_FIELD_STATUS_LOST"
    },
    Enum: {
        NEW: "01",
        IN_PROPOSAL: "02",
        IN_COMMUNICATE: "03",
        IN_SCHEDULE: "04",
        IN_INTENTION: "05",
        IN_CONTRACT: "06",
        IN_RECEIVE: "07",
        COMPLETED: "08",
        POSTPONED: "09",
        LOST: "10",
    }
};
export const OpportunityGrade = {
    List: [
        { value: "01", label: "WMS_BUSINESS_OPPORTUNITY_FIELD_GRADE_1" },
        { value: "02", label: "WMS_BUSINESS_OPPORTUNITY_FIELD_GRADE_2" },
        { value: "03", label: "WMS_BUSINESS_OPPORTUNITY_FIELD_GRADE_3" }

    ],
    Map: {
        "01": "WMS_BUSINESS_OPPORTUNITY_FIELD_GRADE_1",
        "02": "WMS_BUSINESS_OPPORTUNITY_FIELD_GRADE_2",
        "03": "WMS_BUSINESS_OPPORTUNITY_FIELD_GRADE_3",
    },
    Enum: {
        GRADE_1: "01",
        GRADE_2: "02",
        GRADE_3: "03",

    }
};
export const SchedulerViewType = {
    List: [
        { value: "01", label: "WMS_BUSINESS_SCHEDULER_FIELD_VIEW_TYPE_ON_SITE" },
        { value: "02", label: "WMS_BUSINESS_SCHEDULER_FIELD_VIEW_TYPE_REMOTE" },
    ],
    Map: {
        "01": "WMS_BUSINESS_SCHEDULER_FIELD_VIEW_TYPE_ON_SITE",
        "02": "WMS_BUSINESS_SCHEDULER_FIELD_VIEW_TYPE_REMOTE",
    },
    Enum: {
        ON_SITE: "01",
        REMOTE: "02",

    }
};
export const OpportunityFieldClassify = {

    List: [
        { value: "01", label: "WMS_BUSINESS_OPPORTUNITY_CLASSIFY_BUSINESS_PROFILE" },
        { value: "02", label: "WMS_BUSINESS_OPPORTUNITY_CLASSIFY_PLANNING_REQUIREMENTS" },
        { value: "03", label: "WMS_BUSINESS_OPPORTUNITY_CLASSIFY_OTHER" },
    ],
    Map: {
        "01": "WMS_BUSINESS_OPPORTUNITY_CLASSIFY_BUSINESS_PROFILE",
        "02": "WMS_BUSINESS_OPPORTUNITY_CLASSIFY_PLANNING_REQUIREMENTS",
        "03": "WMS_BUSINESS_OPPORTUNITY_CLASSIFY_OTHER",
    },
    Enum: {
        Profile: "01",
        Spec: "02",
        Other: "03"
    }
};

export const SummaryZoneLevels = {
    Enum: {
        DISTRICT: "DISTRICT",
        TOWN: "TOWN"
    }
}
export const SummaryBrandColorArray = [

    '#9966CC', '#046AFF', '#66CCCC', '#339933',
    '#FFFF00', '#FF9933', '#FF0033',
    '#FF33CC', '#0000FF', '#99CC00',
    '#FF6666', '#66CC99', '#FF3399',
    '#FF99CC', '#CCCCFF',
];
export const ProposalBrandColorArray = [

    '#046AFF', '#9966CC', '#66CCCC', '#339933',
    '#FF9933', '#FF0033',
    '#FF33CC', '#0000FF',
    '#FF6666', '#66CC99', '#FF3399',
    '#FF99CC',
];
export const ProposalSortTypes = {
    List: [
        { value: "00", label: "WMS_BUSINESS_OPPORTUNITY_SORT_TYPE_NULL" },
        { value: "01", label: "WMS_BUSINESS_OPPORTUNITY_SORT_TYPE_CUSTOM" },
        { value: "02", label: "WMS_BUSINESS_OPPORTUNITY_SORT_TYPE_ASC" },
        { value: "03", label: "WMS_BUSINESS_OPPORTUNITY_SORT_TYPE_DESC" },
    ],
    Map: {
        "00": "WMS_BUSINESS_OPPORTUNITY_SORT_TYPE_NULL",
        "01": "WMS_BUSINESS_OPPORTUNITY_SORT_TYPE_CUSTOM",
        "02": "WMS_BUSINESS_OPPORTUNITY_SORT_TYPE_ASC",
        "03": "WMS_BUSINESS_OPPORTUNITY_SORT_TYPE_DESC",
    },
    Enum: {
        NULL: "00",
        CUSTOM: "01",
        ASC: "02",
        DESC: "03",
    }
}
export const ProposalSortFields = {

    Map: {
        "distance": "WMS_BUSINESS_OPPORTUNITY_FIELD_DISTANCE",
        "rentEffective": "WMS_BUSINESS_OPPORTUNITY_FIELD_RENT",
        "rentalAreaMin": "WMS_BUSINESS_OPPORTUNITY_FIELD_RENT_AREA_MIN",
        "vacantArea": "WMS_BUSINESS_OPPORTUNITY_FIELD_VACANT_AREA",
        "rentalDate": "WMS_BUSINESS_OPPORTUNITY_FIELD_RENTAL_DATE",

    },
    Enum: {
        NULL: "",
        DISTANCE: "distance",
        RENT: "rentEffective",
        RENT_AREA_MIN: "rentalAreaMin",
        VACANT_AREA: "vacantArea",
        RENTAL_DATE: "rentalDate",
    }
}
export const ProposalImproperReasonCode = {
    List: [
        { value: "1", label: "WMS_PROPOSAL_IMPROPER_REASON_CODE_POSITION" },
        { value: "2", label: "WMS_PROPOSAL_IMPROPER_REASON_CODE_SPEC" },
        { value: "3", label: "WMS_PROPOSAL_IMPROPER_REASON_CODE_TIME" },
        { value: "4", label: "WMS_PROPOSAL_IMPROPER_REASON_CODE_AREA" },
        { value: "5", label: "WMS_PROPOSAL_IMPROPER_REASON_CODE_TAX" },
        { value: "6", label: "WMS_PROPOSAL_IMPROPER_REASON_CODE_COMPETITOR" },
        { value: "7", label: "WMS_PROPOSAL_IMPROPER_REASON_CODE_THIRD_PARTY" },
        { value: "8", label: "WMS_PROPOSAL_IMPROPER_REASON_CODE_OTHER" }
    ],
    Map: {
        "1": "WMS_PROPOSAL_IMPROPER_REASON_CODE_POSITION",
        "2": "WMS_PROPOSAL_IMPROPER_REASON_CODE_SPEC",
        "3": "WMS_PROPOSAL_IMPROPER_REASON_CODE_TIME",
        "4": "WMS_PROPOSAL_IMPROPER_REASON_CODE_AREA",
        "5": "WMS_PROPOSAL_IMPROPER_REASON_CODE_TAX",
        "6": "WMS_PROPOSAL_IMPROPER_REASON_CODE_COMPETITOR",
        "7": "WMS_PROPOSAL_IMPROPER_REASON_CODE_THIRD_PARTY",
        "8": "WMS_PROPOSAL_IMPROPER_REASON_CODE_OTHER"
    },
    Enum: {
        POSITION: "1",
        SPEC: "2",
        TIME: "3",
        AREA: "4",
        TAX: "5",
        COMPETITOR: "6",
        THIRD_PARTY: "7",
        OTHER: "8"
    }
};
export const OpportunityDiscardReasonType = {
    List: [
        { value: "01", label: "WMS_BUSINESS_OPPORTUNITY_DISCARD_REASON_PROBLEM_ONE" },
        { value: "02", label: "WMS_BUSINESS_OPPORTUNITY_DISCARD_REASON_PROBLEM_TWO" },
        { value: "03", label: "WMS_BUSINESS_OPPORTUNITY_DISCARD_REASON_PROBLEM_TREE" },
        { value: "04", label: "WMS_BUSINESS_OPPORTUNITY_DISCARD_REASON_PROBLEM_FOUR" },
        { value: "05", label: "WMS_BUSINESS_OPPORTUNITY_DISCARD_REASON_PROBLEM_FIVE" },
        { value: "06", label: "WMS_BUSINESS_OPPORTUNITY_DISCARD_REASON_PROBLEM_SIX" },
        { value: "07", label: "WMS_BUSINESS_OPPORTUNITY_DISCARD_REASON_PROBLEM_SEVEN" },
        { value: "08", label: "WMS_BUSINESS_OPPORTUNITY_DISCARD_REASON_PROBLEM_EIGHT" },
        { value: "09", label: "WMS_BUSINESS_OPPORTUNITY_DISCARD_REASON_PROBLEM_NINE" },
        { value: "10", label: "WMS_BUSINESS_OPPORTUNITY_DISCARD_REASON_PROBLEM_TEN" }
    ],
    Map: {
        "01": "WMS_BUSINESS_OPPORTUNITY_DISCARD_REASON_PROBLEM_ONE",
        "02": "WMS_BUSINESS_OPPORTUNITY_DISCARD_REASON_PROBLEM_TWO",
        "03": "WMS_BUSINESS_OPPORTUNITY_DISCARD_REASON_PROBLEM_TREE",
        "04": "WMS_BUSINESS_OPPORTUNITY_DISCARD_REASON_PROBLEM_FOUR",
        "05": "WMS_BUSINESS_OPPORTUNITY_DISCARD_REASON_PROBLEM_FIVE",
        "06": "WMS_BUSINESS_OPPORTUNITY_DISCARD_REASON_PROBLEM_SIX",
        "07": "WMS_BUSINESS_OPPORTUNITY_DISCARD_REASON_PROBLEM_SEVEN",
        "08": "WMS_BUSINESS_OPPORTUNITY_DISCARD_REASON_PROBLEM_EIGHT",
        "09": "WMS_BUSINESS_OPPORTUNITY_DISCARD_REASON_PROBLEM_NINE",
        "10": "WMS_BUSINESS_OPPORTUNITY_DISCARD_REASON_PROBLEM_TEN"
    },
    Enum: {
        ONE: "01",
        TWO: "02",
        TREE: "03",
        FOUR: "04",
        FIVE: "05",
        SIX: "06",
        SEVEN: "07",
        EIGHT: "08",
        NINE: "09",
        TEN: "10"
    }
};
export const LandUseNatureType = {
    List: [
        { value: "01", label: "WMS_LAND_FIELD_DATA_IMPORT_USE_INDUSTRIAL_LAND" },
    ],
    Map: {
        "01": "WMS_LAND_FIELD_DATA_IMPORT_USE_INDUSTRIAL_LAND",
    },
    Enum: {
        IndustrialLand: "01",
    }
};
export const LandPlanNatureType = {
    List: [
        { value: "01", label: "WMS_LAND_FIELD_DATA_IMPORT_USE_INDUSTRIAL_LAND" },
    ],
    Map: {
        "01": "WMS_LAND_FIELD_DATA_IMPORT_USE_INDUSTRIAL_LAND",
    },
    Enum: {
        IndustrialLand: "01",
    }
};


export const IntentionMaterialType = {
    List: [
        { value: "01", label: "WMS_BUSINESS_INTENTION_TYPE_FIRE_CHECK_REPORT" },
        { value: "02", label: "WMS_BUSINESS_INTENTION_TYPE_HOUSE_CERTIFICATE" },
        { value: "03", label: "WMS_BUSINESS_INTENTION_TYPE_ZONE_TOTAL_VIEW" },
        { value: "04", label: "WMS_BUSINESS_INTENTION_TYPE_CAD_DRAWINGS" },
        { value: "05", label: "WMS_BUSINESS_INTENTION_TYPE_RENT_AREA_TABLE" },
        { value: "06", label: "WMS_BUSINESS_INTENTION_TYPE_PROJECT_INTRODUCTION" },
        { value: "07", label: "WMS_BUSINESS_INTENTION_TYPE_ZONE_PHOTO" },
        { value: "08", label: "WMS_BUSINESS_INTENTION_TYPE_LAND_CERTIFICATE" },
        { value: "09", label: "WMS_BUSINESS_INTENTION_TYPE_PROJECT_PLAN_CERTIFICATE" },
        { value: "10", label: "WMS_BUSINESS_INTENTION_TYPE_PROJECT_WORK_CERTIFICATE" },
        { value: "11", label: "WMS_BUSINESS_INTENTION_TYPE_ZONE_HORIZONTAL_VERTICAL_VIEW" },
        { value: "12", label: "WMS_BUSINESS_INTENTION_TYPE_BUSINESS_LICENSE" },
        { value: "13", label: "WMS_BUSINESS_INTENTION_TYPE_SELLING_POINT" },

    ],
    Map: {
        "01": "WMS_BUSINESS_INTENTION_TYPE_FIRE_CHECK_REPORT",
        "02": "WMS_BUSINESS_INTENTION_TYPE_HOUSE_CERTIFICATE",
        "03": "WMS_BUSINESS_INTENTION_TYPE_ZONE_TOTAL_VIEW",
        "04": "WMS_BUSINESS_INTENTION_TYPE_CAD_DRAWINGS",
        "05": "WMS_BUSINESS_INTENTION_TYPE_RENT_AREA_TABLE",
        "06": "WMS_BUSINESS_INTENTION_TYPE_PROJECT_INTRODUCTION",
        "07": "WMS_BUSINESS_INTENTION_TYPE_ZONE_PHOTO",
        "08": "WMS_BUSINESS_INTENTION_TYPE_LAND_CERTIFICATE",
        "09": "WMS_BUSINESS_INTENTION_TYPE_PROJECT_PLAN_CERTIFICATE",
        "10": "WMS_BUSINESS_INTENTION_TYPE_PROJECT_WORK_CERTIFICATE",
        "11": "WMS_BUSINESS_INTENTION_TYPE_ZONE_HORIZONTAL_VERTICAL_VIEW",
        "12": "WMS_BUSINESS_INTENTION_TYPE_BUSINESS_LICENSE",
        "13": "WMS_BUSINESS_INTENTION_TYPE_SELLING_POINT",
    },
    DataMap: {
        "01": { label: "WMS_BUSINESS_INTENTION_TYPE_FIRE_CHECK_REPORT", zoneFileTag: ZoneFileTag.Enum.FIRE_CHECK_REPORT },
        "02": { label: "WMS_BUSINESS_INTENTION_TYPE_HOUSE_CERTIFICATE", zoneFileTag: ZoneFileTag.Enum.HOUSE_CERTIFICATE },
        "03": { label: "WMS_BUSINESS_INTENTION_TYPE_ZONE_TOTAL_VIEW", zoneFileTag: ZoneFileTag.Enum.ZONE_TOTAL_VIEW },
        "04": { label: "WMS_BUSINESS_INTENTION_TYPE_CAD_DRAWINGS", zoneFileTag: ZoneFileTag.Enum.CAD_DRAWINGS },
        "05": { label: "WMS_BUSINESS_INTENTION_TYPE_RENT_AREA_TABLE", zoneFileTag: ZoneFileTag.Enum.NONE },
        "06": {
            label: "WMS_BUSINESS_INTENTION_TYPE_PROJECT_INTRODUCTION",
            zoneFileTag: ZoneFileTag.Enum.PROJECT_INTRODUCTION
        },
        "07": { label: "WMS_BUSINESS_INTENTION_TYPE_ZONE_PHOTO", zoneFileTag: ZoneFileTag.Enum.NONE },
        "08": { label: "WMS_BUSINESS_INTENTION_TYPE_LAND_CERTIFICATE", zoneFileTag: ZoneFileTag.Enum.LAND_CERTIFICATE },
        "09": {
            label: "WMS_BUSINESS_INTENTION_TYPE_PROJECT_PLAN_CERTIFICATE",
            zoneFileTag: ZoneFileTag.Enum.PROJECT_PLAN_CERTIFICATE
        },
        "10": {
            label: "WMS_BUSINESS_INTENTION_TYPE_PROJECT_WORK_CERTIFICATE",
            zoneFileTag: ZoneFileTag.Enum.PROJECT_WORK_CERTIFICATE
        },
        "11": {
            label: "WMS_BUSINESS_INTENTION_TYPE_ZONE_HORIZONTAL_VERTICAL_VIEW",
            zoneFileTag: ZoneFileTag.Enum.ZONE_HORIZONTAL_VERTICAL_VIEW
        },
        "12": { label: "WMS_BUSINESS_INTENTION_TYPE_BUSINESS_LICENSE", zoneFileTag: ZoneFileTag.Enum.BUSINESS_LICENSE },
        "13": { label: "WMS_BUSINESS_INTENTION_TYPE_SELLING_POINT", zoneFileTag: ZoneFileTag.Enum.NONE },

    },
    Enum: {
        FIRE_CHECK_REPORT: "01",
        HOUSE_CERTIFICATE: "02",
        ZONE_TOTAL_VIEW: "03",
        CAD_DRAWINGS: "04",
        RENT_AREA_TABLE: "05",
        PROJECT_INTRODUCTION: "06",
        ZONE_PHOTO: "07",
        LAND_CERTIFICATE: "08",
        PROJECT_PLAN_CERTIFICATE: "09",
        PROJECT_WORK_CERTIFICATE: "10",
        ZONE_HORIZONTAL_VERTICAL_VIEW: "11",
        BUSINESS_LICENSE: "12",
        SELLING_POINT: "13",
    }
};
export const IntentionStatus = {
    List: [
        { value: "00", label: "WMS_BUSINESS_INTENTION_STATUS_NEW" },
        { value: "01", label: "WMS_BUSINESS_INTENTION_STATUS_SEND_MAIL" },

    ],
    Map: {
        "00": "WMS_BUSINESS_INTENTION_STATUS_NEW",
        "01": "WMS_BUSINESS_INTENTION_STATUS_SEND_MAIL",

    },

    Enum: {
        NEW: "00",
        SEND_MAIL: "01",
    }
};
export const IntentionMaterialStatus = {
    List: [
        { value: "00", label: "WMS_BUSINESS_INTENTION_MATERIAL_STATUS_NO_UPLOAD" },
        { value: "01", label: "WMS_BUSINESS_INTENTION_MATERIAL_STATUS_WAIT_UPLOAD" },
        { value: "02", label: "WMS_BUSINESS_INTENTION_MATERIAL_STATUS_UPLOADED" },
    ],
    Map: {
        "00": "WMS_BUSINESS_INTENTION_MATERIAL_STATUS_NO_UPLOAD",
        "01": "WMS_BUSINESS_INTENTION_MATERIAL_STATUS_WAIT_UPLOAD",
        "02": "WMS_BUSINESS_INTENTION_MATERIAL_STATUS_UPLOADED",
    },
    SellPointMap: {
        "00": "WMS_BUSINESS_INTENTION_MATERIAL_STATUS_NO_UPLOAD",
        "01": "WMS_BUSINESS_INTENTION_MATERIAL_STATUS_WAIT_UPLOAD",
        "02": "WMS_BUSINESS_INTENTION_MATERIAL_STATUS_UPLOADED",
    },
    Enum: {
        NO_UPLOAD: "00",
        WAIT_UPLOAD: "01",
        UPLOADED: "02",
    }
};
export const IntentionMaterialConfirmStatus = {
    List: [
        { value: "01", label: "WMS_BUSINESS_INTENTION_MATERIAL_CONFIRM_STATUS_NEED_UPLOAD" },
        { value: "02", label: "WMS_BUSINESS_INTENTION_MATERIAL_CONFIRM_STATUS_NO_NEED_UPLOAD" },
        { value: "03", label: "WMS_BUSINESS_INTENTION_MATERIAL_CONFIRM_STATUS_WAIT_CONFIRM" },
        { value: "04", label: "WMS_BUSINESS_INTENTION_MATERIAL_CONFIRM_STATUS_CONFIRM" },
        { value: "05", label: "WMS_BUSINESS_INTENTION_MATERIAL_CONFIRM_STATUS_NO_CONFIRM" },
    ],
    Map: {
        "01": "WMS_BUSINESS_INTENTION_MATERIAL_CONFIRM_STATUS_NEED_UPLOAD",
        "02": "WMS_BUSINESS_INTENTION_MATERIAL_CONFIRM_STATUS_NO_NEED_UPLOAD",
        "03": "WMS_BUSINESS_INTENTION_MATERIAL_CONFIRM_STATUS_WAIT_CONFIRM",
        "04": "WMS_BUSINESS_INTENTION_MATERIAL_CONFIRM_STATUS_CONFIRM",
        "05": "WMS_BUSINESS_INTENTION_MATERIAL_CONFIRM_STATUS_NO_CONFIRM",
    },
    noUploadList: [
        { value: "01", label: "WMS_BUSINESS_INTENTION_MATERIAL_CONFIRM_STATUS_NEED_UPLOAD" },
        { value: "02", label: "WMS_BUSINESS_INTENTION_MATERIAL_CONFIRM_STATUS_NO_NEED_UPLOAD" },
    ],
    uploadedList: [
        { value: "03", label: "WMS_BUSINESS_INTENTION_MATERIAL_CONFIRM_STATUS_WAIT_CONFIRM" },
        { value: "04", label: "WMS_BUSINESS_INTENTION_MATERIAL_CONFIRM_STATUS_CONFIRM" },
        { value: "05", label: "WMS_BUSINESS_INTENTION_MATERIAL_CONFIRM_STATUS_NO_CONFIRM" },
    ],
    Enum: {
        NEED_UPLOAD: "01",
        NO_NEED_UPLOAD: "02",
        WAIT_CONFIRM: "03",
        CONFIRM: "04",
        NO_CONFIRM: "05",
    }
};
export const RentCalculateSplitType = {
    List: [
        { value: "00", label: "WMS_RENT_CALCULATE_NO_NEED_SPLIT" },
        { value: "01", label: "WMS_RENT_CALCULATE_NEED_SPLIT" },
    ],
    Map: {
        "00": "WMS_RENT_CALCULATE_NO_NEED_SPLIT",
        "01": "WMS_RENT_CALCULATE_NEED_SPLIT",
    },
    Enum: {
        NO_NEED_SPLIT: "00",
        NEED_SPLIT: "01",
    }
};
export const ResearchReportStatus = {
    List: [
        { value: "01", label: "WMS_RESEARCH_REPORT_FIELD_STATUS_CONTINUE" },
        { value: "02", label: "WMS_RESEARCH_REPORT_FIELD_STATUS_COMPLETE" },
    ],
    Map: {
        "01": "WMS_RESEARCH_REPORT_FIELD_STATUS_CONTINUE",
        "02": "WMS_RESEARCH_REPORT_FIELD_STATUS_COMPLETE",
    },
    Enum: {

        Continue: "01",
        Complete: "02",
    }
};
export const ResearchServiceType = {
    List: [
        { value: "01", label: "WMS_RESEARCH_REPORT_FIELD_SERVICE_TYPE_ONCE" },
        { value: "02", label: "WMS_RESEARCH_REPORT_FIELD_SERVICE_TYPE_MONTH" },
    ],
    Map: {
        "01": "WMS_RESEARCH_REPORT_FIELD_SERVICE_TYPE_ONCE",
        "02": "WMS_RESEARCH_REPORT_FIELD_SERVICE_TYPE_MONTH",
    },
    Enum: {

        ONCE: "01",
        MONTH: "02",
    }
};
export const ResearchPurpose = {
    List: [
        { value: "01", label: "WMS_RESEARCH_REPORT_FIELD_PURPOSE_INVESTMENT" },
        { value: "02", label: "WMS_RESEARCH_REPORT_FIELD_PURPOSE_MARKET" },
    ],
    Map: {
        "01": "WMS_RESEARCH_REPORT_FIELD_PURPOSE_INVESTMENT",
        "02": "WMS_RESEARCH_REPORT_FIELD_PURPOSE_MARKET",
    },
    Enum: {

        Investment: "01",
        Market: "02",
    }
};

export const ResearchProposalList = {
    List: [
        { value: "number", label: "WMS_RESEARCH_REPORT_FIELD_ZONE_NUMBER" },
        { value: "num", label: "WMS_RESEARCH_REPORT_FIELD_NUM" },
        { value: "brandName", label: "WMS_RESEARCH_REPORT_FIELD_BRAND" },
        { value: "name", label: "WMS_RESEARCH_REPORT_FIELD_NAME" },
        { value: "distance", label: "WMS_RESEARCH_REPORT_FIELD_DISTANCE" },
        { value: "buildingArea", label: "WMS_RESEARCH_REPORT_FIELD_BUILDING_AREA" },
        { value: "vacantArea", label: "WMS_RESEARCH_REPORT_FIELD_VACANT_AREA" },
        { value: "vacancyRate", label: "WMS_RESEARCH_REPORT_FIELD_VACANCY_RATE" },
        { value: "status", label: "WMS_RESEARCH_REPORT_FIELD_ZONE_STATUS" },

        { value: "buildingType", label: "WMS_RESEARCH_REPORT_FIELD_BUILDING_TYPE" },

        { value: "rentWithPropertyNoFax", label: "WMS_RESEARCH_REPORT_FIELD_RENT" },
        // {value: "rentTaxType", label: "WMS_RESEARCH_REPORT_FIELD_RENT_TAX_TYPE"},
        // {value: "rentTaxRate", label: "WMS_RESEARCH_REPORT_FIELD_RENT_TAX_RATE"},
        { value: "rentFreeCondition", label: "WMS_RESEARCH_REPORT_FIELD_RENT_FREE_CONDITION" },
        { value: "rentEffective", label: "WMS_RESEARCH_REPORT_FIELD_RENT_EFFECTIVE" },

        { value: "leaseList", label: "WMS_RESEARCH_REPORT_FIELD_LEASEE" },
        { value: "rentSuccessful", label: "WMS_RESEARCH_REPORT_FIELD_RENT_SUCCESSFUL" },
        { value: "remake", label: "WMS_RESEARCH_REPORT_FIELD_REMAKE" },
    ],
    Map: {
        "number": "WMS_RESEARCH_REPORT_FIELD_ZONE_NUMBER",
        "num": "WMS_RESEARCH_REPORT_FIELD_NUM",
        "brandName": "WMS_RESEARCH_REPORT_FIELD_BRAND",
        "distance": "WMS_RESEARCH_REPORT_FIELD_DISTANCE",
        "name": "WMS_RESEARCH_REPORT_FIELD_NAME",
        "buildingArea": "WMS_RESEARCH_REPORT_FIELD_BUILDING_AREA",
        "vacantArea": "WMS_RESEARCH_REPORT_FIELD_VACANT_AREA",
        "vacancyRate": "WMS_RESEARCH_REPORT_FIELD_VACANCY_RATE",
        "status": "WMS_RESEARCH_REPORT_FIELD_ZONE_STATUS",

        "buildingType": "WMS_RESEARCH_REPORT_FIELD_BUILDING_TYPE",

        "rentWithPropertyNoFax": "WMS_RESEARCH_REPORT_FIELD_RENT",
        "rentTaxType": "WMS_RESEARCH_REPORT_FIELD_RENT_TAX_TYPE",
        "rentTaxRate": "WMS_RESEARCH_REPORT_FIELD_RENT_TAX_RATE",
        "rentFreeCondition": "WMS_RESEARCH_REPORT_FIELD_RENT_FREE_CONDITION",
        "rentEffective": "WMS_RESEARCH_REPORT_FIELD_RENT_EFFECTIVE",

        "leaseList": "WMS_RESEARCH_REPORT_FIELD_LEASEE",
        "rentSuccessful": "WMS_RESEARCH_REPORT_FIELD_RENT_SUCCESSFUL",
        "remake": "WMS_RESEARCH_REPORT_FIELD_REMAKE",
    },
    Enum: {
        number: "number",
        num: "num",
        brandName: "brandName",
        distance: "distance",
        name: "name",
        buildingArea: "buildingArea",
        vacantArea: "vacantArea",
        vacancyRate: "vacancyRate",
        status: "status",

        buildingType: "buildingType",

        rentWithPropertyNoFax: "rentWithPropertyNoFax",
        rentTaxType: "rentTaxType",
        rentTaxRate: "rentTaxRate",
        rentFreeCondition: "rentFreeCondition",
        rentEffective: "rentEffective",

        leaseList: "leaseList",
        rentSuccessful: "rentSuccessful",
        remake: "remake",
    }

};
export const ResearchProposalSortFields = {

    Map: {
        "distance": "WMS_RESEARCH_REPORT_FIELD_DISTANCE",

        "buildingArea": "WMS_RESEARCH_REPORT_FIELD_BUILDING_AREA",
        "vacantArea": "WMS_RESEARCH_REPORT_FIELD_VACANT_AREA",

    },
    Enum: {
        NULL: "",
        DISTANCE: "distance",
        BUILDING_AREA: "buildingArea",
        VACANT_AREA: "vacantArea",
    }
}
export const IntentionLetterPayType = {
    List: [
        { value: "01", label: "WMS_INTENTION_LETTER_FIELD_PAY_TYPE_FIRST_PAY" },
        { value: "02", label: "WMS_INTENTION_LETTER_FIELD_PAY_TYPE_FIRST_USE" },
    ],
    Map: {
        "01": "WMS_INTENTION_LETTER_FIELD_PAY_TYPE_FIRST_PAY",
        "02": "WMS_INTENTION_LETTER_FIELD_PAY_TYPE_FIRST_USE",
    },
    Enum: {
        FirstPay: "01",
        FirstUse: "02",
    }
};
export const IntentionLetterHouseDeliveryCondition = {
    List: [
        { value: "01", label: "WMS_INTENTION_LETTER_FIELD_DELIVERY_CONDITION_KEEP_SAME" },
        { value: "02", label: "WMS_INTENTION_LETTER_FIELD_DELIVERY_CONDITION_REFORM" },
    ],
    Map: {
        "01": "WMS_INTENTION_LETTER_FIELD_DELIVERY_CONDITION_KEEP_SAME",
        "02": "WMS_INTENTION_LETTER_FIELD_DELIVERY_CONDITION_REFORM",
    },
    Enum: {
        KeepSame: "01",
        Reform: "02",
    }
};
export const IntentionLetterHasMoney = {
    List: [
        { value: "01", label: "WMS_INTENTION_LETTER_FIELD_MONEY_FLAG_HAS_MONEY" },
        { value: "02", label: "WMS_INTENTION_LETTER_FIELD_MONEY_FLAG_NO_MONEY" },
    ],
    Map: {
        "01": "WMS_INTENTION_LETTER_FIELD_MONEY_FLAG_HAS_MONEY",
        "02": "WMS_INTENTION_LETTER_FIELD_MONEY_FLAG_NO_MONEY",
    },
    Enum: {
        HasMoney: "01",
        NoMoney: "02",
    }
};
export const IntentionLetterShowHeaderFlag = {
    List: [

        { value: "02", label: "WMS_INTENTION_LETTER_FIELD_HEADER_FLAG_NO" },
        { value: "01", label: "WMS_INTENTION_LETTER_FIELD_HEADER_FLAG_HAS" },
    ],
    Map: {
        "01": "WMS_INTENTION_LETTER_FIELD_HEADER_FLAG_HAS",
        "02": "WMS_INTENTION_LETTER_FIELD_HEADER_FLAG_NO",

    },
    Enum: {
        Has: "01",
        No: "02",

    }
};
export const IntentionLetterInvoiceType = {
    List: [
        { value: "01", label: "WMS_INTENTION_FIELD_RENT_INVOICE_TYPE_HOUSE_RENT" },
        { value: "02", label: "WMS_INTENTION_FIELD_RENT_INVOICE_TYPE_WAREHOUSE_SERVICE" },
    ],
    Map: {
        "01": "WMS_INTENTION_FIELD_RENT_INVOICE_TYPE_HOUSE_RENT",
        "02": "WMS_INTENTION_FIELD_RENT_INVOICE_TYPE_WAREHOUSE_SERVICE",
    },
    Enum: {
        HouseRent: "01",
        WarehouseService: "02",
    }
};
export const ContactsLessorTags = {
    List: [
        { value: "01", label: "WMS_CONTACTS_LESSOR_TAGS_LESSOR" },
        { value: "02", label: "WMS_CONTACTS_LESSOR_TAGS_INTERMEDIARY" },
        { value: "03", label: "WMS_CONTACTS_LESSOR_TAGS_SUBLEASE" },
        { value: "04", label: "WMS_CONTACTS_LESSOR_TAGS_MIDDLEMAN_LESSOR" },
    ],
    Map: {
        "01": "WMS_CONTACTS_LESSOR_TAGS_LESSOR",
        "02": "WMS_CONTACTS_LESSOR_TAGS_INTERMEDIARY",
        "03": "WMS_CONTACTS_LESSOR_TAGS_SUBLEASE",
        "04": "WMS_CONTACTS_LESSOR_TAGS_MIDDLEMAN_LESSOR",
    },
    Enum: {
        Lessor: "01",
        Intermediary: "02",
        Sublease: "03",
        MiddlemanLessor: "04",
    }
};
//临时记录一下，根据客户会修改显示内容枚举值
export const ResearchReportSelfEvaluation = {
    List: [

        { value: "1", label: "1" },
        { value: "2", label: "2" },
        { value: "3", label: "3" },
        { value: "4", label: "4" },
        { value: "5", label: "5" },

    ],
    Map: {
        "1": "1",
        "2": "2",
        "3": "3",
        "4": "4",
        "5": "5",
    },

};
export const IMAGE_WATER_PARAM = "/watermark,image_RmlsZS93YXRlcjEucG5nP3gtb3NzLXByb2Nlc3M9aW1hZ2UvcmVzaXplLFBfNDA=,t_40,g_nw,x_10,y_10" +
    "/watermark,image_RmlsZS93YXRlcjEucG5nP3gtb3NzLXByb2Nlc3M9aW1hZ2UvcmVzaXplLFBfNDA=,t_40,g_ne,x_10,y_10" +
    "/watermark,image_RmlsZS93YXRlcjEucG5nP3gtb3NzLXByb2Nlc3M9aW1hZ2UvcmVzaXplLFBfNDA=,t_40,g_west,x_10,y_10" +
    // "/watermark,image_RmlsZS93YXRlcjEucG5nP3gtb3NzLXByb2Nlc3M9aW1hZ2UvcmVzaXplLFBfNDA=,t_40,g_center,x_10,y_10" +
    "/watermark,image_RmlsZS93YXRlcjEucG5nP3gtb3NzLXByb2Nlc3M9aW1hZ2UvcmVzaXplLFBfNDA=,t_40,g_east,x_10,y_10" +
    "/watermark,image_RmlsZS93YXRlcjEucG5nP3gtb3NzLXByb2Nlc3M9aW1hZ2UvcmVzaXplLFBfNDA=,t_40,g_sw,x_10,y_10" +
    "/watermark,image_RmlsZS93YXRlcjEucG5nP3gtb3NzLXByb2Nlc3M9aW1hZ2UvcmVzaXplLFBfNDA=,t_40,g_se,x_10,y_10";


export const CONTRACT_TAGS = {
    List: [
        { value: "01", label: "WMS_CONTRACT_TAGS_DISCUSS" },
        { value: "02", label: "WMS_CONTRACT_TAGS_FINALIZATION" },
        { value: "03", label: "WMS_CONTRACT_TAGS_SEAL" },

    ],
    Map: {
        "01": "WMS_CONTRACT_TAGS_DISCUSS",
        "02": "WMS_CONTRACT_TAGS_FINALIZATION",
        "03": "WMS_CONTRACT_TAGS_SEAL",

    },
    Enum: {
        Discuss: "01",
        Finalization: "02",
        Seal: "03",
    }
};
export const CONTRACT_TYPE = {
    List: [
        { value: "01", label: "WMS_CONTRACT_TYPE_LEASE" },
        { value: "02", label: "WMS_CONTRACT_TYPE_SERVICE" },

    ],
    Map: {
        "01": "WMS_CONTRACT_TYPE_LEASE",
        "02": "WMS_CONTRACT_TYPE_SERVICE",

    },
    Enum: {
        Lease: "01",
        Service: "02",
    }
};

export const BusinessServiceContractCompanyClassifier = {
    List: [
        { value: "01", label: "WMS_BUSINESS_SERVICE_CONTRACT_FIELD_COMPANY_CLASSIFIER_LESSOR" },
        { value: "02", label: "WMS_BUSINESS_SERVICE_CONTRACT_FIELD_COMPANY_CLASSIFIER_LESSEE" },

    ],
    Map: {
        "01": "WMS_BUSINESS_SERVICE_CONTRACT_FIELD_COMPANY_CLASSIFIER_LESSOR",
        "02": "WMS_BUSINESS_SERVICE_CONTRACT_FIELD_COMPANY_CLASSIFIER_LESSEE",

    },
    Enum: {
        Lessor: "01",
        Lessee: "02",
    }
};

export const BUSINESS_FEE_BILL_STATUS = {
    List: [
        { value: "01", label: "WMS_BUSINESS_FEE_BILL_STATUS_NO" },
        { value: "02", label: "WMS_BUSINESS_FEE_BILL_STATUS_YES" },
    ],
    Map: {
        "01": "WMS_BUSINESS_FEE_BILL_STATUS_NO",
        "02": "WMS_BUSINESS_FEE_BILL_STATUS_YES",
    },
    Enum: {
        NO: "01",
        YES: "02",
    }
};
export const BUSINESS_FEE_COLLECTION_STATUS = {
    List: [
        { value: "01", label: "WMS_BUSINESS_FEE_COLLECTION_STATUS_NO" },
        { value: "02", label: "WMS_BUSINESS_FEE_COLLECTION_STATUS_YES" },
    ],
    Map: {
        "01": "WMS_BUSINESS_FEE_COLLECTION_STATUS_NO",
        "02": "WMS_BUSINESS_FEE_COLLECTION_STATUS_YES",
    },
    Enum: {
        NO: "01",
        YES: "02",
    }
};

export const ToDoStatusFieldStatus = {
    List: [
        { value: "", label: "WMS_TODO_STATUS_FIELD_STATUS_ALL" },
        { value: "01", label: "WMS_TODO_STATUS_FIELD_STATUS_WAIT" },
        // {value: "02", label: "WMS_TODO_STATUS_READ"},
        { value: "03", label: "WMS_TODO_STATUS_FIELD_STATUS_ACCEPT" },
        { value: "04", label: "WMS_TODO_STATUS_FIELD_STATUS_REJECT" },
        { value: "10", label: "WMS_TODO_STATUS_FIELD_STATUS_USELESS" }

    ],
    Map: {
        "01": "WMS_TODO_STATUS_FIELD_STATUS_WAIT",
        "02": "WMS_TODO_STATUS_FIELD_STATUS_READ",
        "03": "WMS_TODO_STATUS_FIELD_STATUS_ACCEPT",
        "04": "WMS_TODO_STATUS_FIELD_STATUS_REJECT",
        "10": "WMS_TODO_STATUS_FIELD_STATUS_USELESS",

    },
    Enum: {
        Wait: "01",
        Read: "02",
        Accept: "03",
        Reject: "04",
        Useless: "10"
    }
};
export const ToDoTableName = {
    List: [
        { value: "", label: "WMS_TODO_FIELD_TABLE_NAME_ALL" },
        { value: "businessFollowup", label: "WMS_TODO_FIELD_TABLE_NAME_FOLLOWUP" },
        { value: "businessOpportunity", label: "WMS_TODO_FIELD_TABLE_NAME_OPPORTUNITY" },
        { value: "researchReport", label: "WMS_TODO_FIELD_TABLE_NAME_RESEARCH" },
        { value: "zone", label: "WMS_TODO_FIELD_TABLE_NAME_ZONE" },

    ],
    Map: {
        "": "WMS_TODO_TYPE_ALL",
        "businessFollowup": "WMS_TODO_FIELD_TABLE_NAME_FOLLOWUP",
        "businessOpportunity": "WMS_TODO_FIELD_TABLE_NAME_OPPORTUNITY",
        "researchReport": "WMS_TODO_FIELD_TABLE_NAME_RESEARCH",
        "zone": "WMS_TODO_FIELD_TABLE_NAME_ZONE",
    },
    Enum: {
        Followup: "businessFollowup",
        Opportunity: "businessOpportunity",
        ResearchReport: "researchReport",
        Zone: "zone",

    }
};
export const ToDoStatus = {
    List: [
        { value: "00", label: "WMS_TODO_FIELD_STATUS_NEW" },
        { value: "01", label: "WMS_TODO_FIELD_STATUS_ACCEPT" },
        { value: "02", label: "WMS_TODO_FIELD_STATUS_COMPLETE" },
        { value: '03', label: "WMS_TODO_FIELD_STATUS_EXPIRE" },
        { value: '04', label: "WMS_TODO_FIELD_STATUS_REJECT" }
    ],
    Map: {
        "00": "WMS_TODO_FIELD_STATUS_NEW",
        "01": "WMS_TODO_FIELD_STATUS_ACCEPT",
        "02": "WMS_TODO_FIELD_STATUS_COMPLETE",
        "03": "WMS_TODO_FIELD_STATUS_EXPIRE",
        "04": "WMS_TODO_FIELD_STATUS_REJECT"

    },
    Enum: {
        New: "00",
        Accept: "01",
        Complete: "02",
        Expire: "03",
        Reject: "04"

    }
};

export const ToDoType = {
    List: [
        { value: "01", label: "WMS_TODO_FIELD_TYPE_CUSTOM" },
        { value: "02", label: "WMS_TODO_FIELD_TYPE_OPPORTUNITY" },
        { value: '03', label: "WMS_TODO_FIELD_TYPE_RESEARCH" },
        { value: '04', label: "WMS_TODO_FIELD_TYPE_ZONE" },
        { value: '05', label: "WMS_TODO_FIELD_TYPE_RESEARCH_ZONE" },
    ],
    SelectList: [
        { value: "", label: "WMS_TODO_FIELD_TYPE_ALL" },

        { value: "02", label: "WMS_TODO_FIELD_TYPE_OPPORTUNITY" },
        { value: '03', label: "WMS_TODO_FIELD_TYPE_RESEARCH" },
        { value: '05', label: "WMS_TODO_FIELD_TYPE_RESEARCH_ZONE" },
        { value: '04', label: "WMS_TODO_FIELD_TYPE_ZONE" },
        { value: "01", label: "WMS_TODO_FIELD_TYPE_CUSTOM" },
    ],
    Map: {
        "01": "WMS_TODO_FIELD_TYPE_CUSTOM",
        "02": "WMS_TODO_FIELD_TYPE_OPPORTUNITY",
        "03": "WMS_TODO_FIELD_TYPE_RESEARCH",
        "04": "WMS_TODO_FIELD_TYPE_ZONE",
        "05": "WMS_TODO_FIELD_TYPE_RESEARCH_ZONE",
    },
    Enum: {
        CUSTOM: "01",
        OPPORTUNITY: "02",
        RESEARCH: "03",
        ZONE: "04",
        RESEARCH_ZONE: "05"
    }
};

export const ToDoListShowType = {
    Enum: {
        ALL: "all",
        NEW: "new",
        ACCEPT: "accept",
        COMPLETE: "complete",
        EXPIRE: "expire",
        REJECT: "reject"

    }
};

//我的任务
export const ToDoStatusListShowType = {
    Enum: {
        NEW: "new",// 等待接单
        MY_ACCEPT: "accept",
        COMPLETE: "complete",
        ALL: "all",


    }
};


export const ResearchReportPatternItem = {
    List: [
        { key: "ZONE_NUMBER", tableTh: "房源编号", name: "房源编号", fieldName: "number", type: "TEXT" },
        { key: "BRAND_NAME", tableTh: "业主", name: "业主", fieldName: "brandName", type: "TEXT" },
        { key: "SHOW_DISTRICT", tableTh: "子市场", name: "子市场", fieldName: "showDistrict", type: "TEXT" },
        { key: "ADDRESS", tableTh: "地址", name: "地址", fieldName: "address", type: "TEXT" },
        { key: "BMAP_LINK", tableTh: "地图链接", name: "地图链接", fieldName: "bmapLink", type: "Link" },
        { key: "DISTANCE", tableTh: "距离圆心（公里）", name: "距离圆心", fieldName: "distance", type: "NUMBER" },
        { key: "ZONE_NAME", tableTh: "项目名称", name: "项目名称", fieldName: "name", type: "TEXT" },
        { key: "BUILDING_AREA", tableTh: "建筑面积 (m2)", name: "建筑面积", fieldName: "buildingArea", type: "NUMBER" },
        { key: "VACANT_AREA", tableTh: "空置面积 (m2)", name: "空置面积", fieldName: "vacantArea", type: "NUMBER" },
        { key: "VACANT_AREA_STRING", tableTh: "可租赁时间", name: "可租赁时间", fieldName: "vacantAreaString", type: "TEXT" },
        {
            key: "VACANT_AREA_ADJUST",
            tableTh: "调整空置面积 (m2)",
            name: "调整空置面积 ",
            fieldName: "vacantAreaAdjust",
            type: "NUMBER"
        },
        { key: "VACANCY_RATE", tableTh: "空置率", name: "空置率", fieldName: "vacancyRate", type: "TEXT" },
        { key: "STATUS", tableTh: "当前状态", name: "当前状态", fieldName: "status", type: "TEXT" },
        { key: "READY_RENT_DATE", tableTh: "竣工时间", name: "竣工时间", fieldName: "readyRentDate", type: "TEXT" },
        { key: "BUILDING_TYPE", tableTh: "建筑类型", name: "建筑类型", fieldName: "buildingType", type: "TEXT" },
        { key: "FLOOR_NUM", tableTh: "层数", name: "层数", fieldName: "floorNum", type: "TEXT" },
        {
            key: "RENT_WITH_PROPERTY_NO_TAX",
            tableTh: "不含税含物业租金报价 (RMB/m²/天）",
            name: "不含税含物业租金报价",
            fieldName: "rentWithPropertyNoTax",
            type: "NUMBER"
        },
        { key: "RENT_TAX_RATE", tableTh: "租金报价税点", name: "租金报价税点", fieldName: "rentTaxRate", type: "TEXT" },
        { key: "RENT_FREE_CONDITION", tableTh: "免租期", name: "免租期", fieldName: "rentFreeCondition", type: "TEXT" },
        { key: "FLOOR_HEIGHT", tableTh: "层高", name: "净高(m)", fieldName: "floorHeight", type: "TEXT" },
        { key: "FLOOR_LOAD", tableTh: "荷载", name: "荷载", fieldName: "floorLoad", type: "TEXT" },
        { key: "PLATFORM", tableTh: "月台", name: "月台", fieldName: "platform", type: "TEXT" },
        { key: "UNLOADING_TYPE", tableTh: "卸货方式", name: "卸货方式", fieldName: "unloadingType", type: "TEXT" },
        { key: "FIRE_RATING", tableTh: "消防等级", name: "消防等级", fieldName: "fireRating", type: "TEXT" },
        { key: "PROPERTY_FEE", tableTh: "物业费", name: "物业费", fieldName: "propertyFee", type: "NUMBER" },
        { key: "RENT_PROPERTY_SPLIT", tableTh: "租金物业拆分", name: "租金物业拆分", fieldName: "rentPropertySplit", type: "TEXT" },
        { key: "RENT_EFFECTIVE", tableTh: "不含税有效租金报价", name: "不含税有效租金报价", fieldName: "rentEffective", type: "NUMBER" },
        {
            key: "CONVERT_RENT_EFFECTIVE",
            tableTh: "折算不含税租金面价报价",
            name: "折算不含税租金面价报价",
            fieldName: "convertRentEffective",
            type: "NUMBER"
        },
        {
            key: "RENT_EFFECTIVE_TAX",
            tableTh: "含税有效租金报价",
            name: "含税有效租金报价",
            fieldName: "rentEffectiveTax",
            type: "NUMBER"
        },
        {
            key: "CONVERT_RENT_EFFECTIVE_TAX",
            tableTh: "折算含税租金面价报价",
            name: "折算含税租金面价报价",
            fieldName: "convertRentEffectiveTax",
            type: "NUMBER"
        },
        { key: "LEASE_LIST", tableTh: "主要租户", name: "主要租户", fieldName: "leaseList", type: "TEXT" },
        { key: "RENT_LEASE", tableTh: "成交不含税有效租金", name: "成交不含税有效租金", fieldName: "rentSuccessful", type: "NUMBER" },
        { key: "LAND_ACQUISITION_DATE", tableTh: "拿地时间", name: "拿地时间", fieldName: "landAcquisitionDate", type: "TEXT" },
        { key: "PLAN_NATURE", tableTh: "土地性质", name: "土地性质", fieldName: "planNature", type: "TEXT" },
        { key: "REMARKS", tableTh: "备注", name: "备注", fieldName: "remarks", type: "TEXT" },
    ],
    SelectList: ["ZONE_NUMBER",
        "BRAND_NAME",
        "ZONE_NAME",
        "SHOW_DISTRICT",
        "ADDRESS",
        "BMAP_LINK",
        "DISTANCE",
        "BUILDING_AREA",
        "VACANT_AREA",
        "VACANT_AREA_STRING",
        // "VACANT_AREA_ADJUST",
        "VACANCY_RATE",
        "STATUS",
        "READY_RENT_DATE",
        "BUILDING_TYPE",
        "FLOOR_NUM",
        "RENT_WITH_PROPERTY_NO_TAX",
        "RENT_TAX_RATE",
        "RENT_FREE_CONDITION",
        "FLOOR_HEIGHT",
        "FLOOR_LOAD",
        "PLATFORM",
        "UNLOADING_TYPE",
        "FIRE_RATING",
        "PROPERTY_FEE",
        "RENT_PROPERTY_SPLIT",
        "RENT_EFFECTIVE",
        "CONVERT_RENT_EFFECTIVE",
        "RENT_EFFECTIVE_TAX",
        "CONVERT_RENT_EFFECTIVE_TAX",
        "LEASE_LIST",
        "RENT_LEASE",
        "LAND_ACQUISITION_DATE",
        "PLAN_NATURE",
        "REMARKS"],
    Map: {
        "ZONE_NUMBER": { key: "ZONE_NUMBER", tableTh: "房源编号", name: "房源编号", fieldName: "number", type: "TEXT" },
        "BRAND_NAME": { key: "BRAND_NAME", tableTh: "业主", name: "业主", fieldName: "brandName", type: "TEXT" },
        "SHOW_DISTRICT": { key: "SHOW_DISTRICT", tableTh: "子市场", name: "子市场", fieldName: "showDistrict", type: "TEXT" },
        "ADDRESS": { key: "ADDRESS", tableTh: "地址", name: "地址", fieldName: "address", type: "TEXT" },
        "BMAP_LINK": { key: "BMAP_LINK", tableTh: "地图链接", name: "地图链接", fieldName: "bmapLink", type: "Link" },
        "DISTANCE": { key: "DISTANCE", tableTh: "距离圆心（公里）", name: "距离圆心", fieldName: "distance", type: "NUMBER" },
        "ZONE_NAME": { key: "ZONE_NAME", tableTh: "项目名称", name: "项目名称", fieldName: "name", type: "TEXT" },
        "BUILDING_AREA": {
            key: "BUILDING_AREA",
            tableTh: "建筑面积 (m2)",
            name: "建筑面积",
            fieldName: "buildingArea",
            type: "NUMBER"
        },
        "VACANT_AREA": {
            key: "VACANT_AREA",
            tableTh: "空置面积 (m2)",
            name: "空置面积",
            fieldName: "vacantArea",
            type: "NUMBER"
        },
        "VACANT_AREA_STRING": {
            key: "VACANT_AREA_STRING",
            tableTh: "可租赁时间",
            name: "可租赁时间",
            fieldName: "vacantAreaString",
            type: "TEXT"
        },
        "VACANT_AREA_ADJUST": {
            key: "VACANT_AREA_ADJUST",
            tableTh: "调整空置面积 (m2)",
            name: "调整空置面积 ",
            fieldName: "vacantAreaAdjust",
            type: "NUMBER"
        },
        "VACANCY_RATE": { key: "VACANCY_RATE", tableTh: "空置率", name: "空置率", fieldName: "vacancyRate", type: "TEXT" },
        "STATUS": { key: "STATUS", tableTh: "当前状态", name: "当前状态", fieldName: "status", type: "TEXT" },
        "READY_RENT_DATE": {
            key: "READY_RENT_DATE",
            tableTh: "竣工时间",
            name: "竣工时间",
            fieldName: "readyRentDate",
            type: "TEXT"
        },
        "BUILDING_TYPE": { key: "BUILDING_TYPE", tableTh: "建筑类型", name: "建筑类型", fieldName: "buildingType", type: "TEXT" },
        "FLOOR_NUM": { key: "FLOOR_NUM", tableTh: "层数", name: "层数", fieldName: "floorNum", type: "TEXT" },
        "RENT_WITH_PROPERTY_NO_TAX": {
            key: "RENT_WITH_PROPERTY_NO_TAX",
            tableTh: "不含税含物业租金报价 (RMB/m²/天）",
            name: "不含税含物业租金报价",
            fieldName: "rentWithPropertyNoTax",
            type: "NUMBER"
        },
        "RENT_WITH_PROPERTY_NO_FAX": {
            key: "RENT_WITH_PROPERTY_NO_TAX",
            tableTh: "不含税含物业租金报价 (RMB/m²/天）",
            name: "不含税含物业租金报价",
            fieldName: "rentWithPropertyNoTax",
            type: "NUMBER"
        },

        "RENT_TAX_RATE": {
            key: "RENT_TAX_RATE",
            tableTh: "租金报价税点",
            name: "租金报价税点",
            fieldName: "rentTaxRate",
            type: "TEXT"
        },
        "RENT_FREE_CONDITION": {
            key: "RENT_FREE_CONDITION",
            tableTh: "免租期",
            name: "免租期",
            fieldName: "rentFreeCondition",
            type: "TEXT"
        },
        "FLOOR_HEIGHT": { key: "FLOOR_HEIGHT", tableTh: "层高", name: "净高(m)", fieldName: "floorHeight", type: "TEXT" },
        "FLOOR_LOAD": { key: "FLOOR_LOAD", tableTh: "荷载", name: "荷载", fieldName: "floorLoad", type: "TEXT" },
        "PLATFORM": { key: "PLATFORM", tableTh: "月台", name: "月台", fieldName: "platform", type: "TEXT" },
        "UNLOADING_TYPE": {
            key: "UNLOADING_TYPE",
            tableTh: "卸货方式",
            name: "卸货方式",
            fieldName: "unloadingType",
            type: "TEXT"
        },
        "FIRE_RATING": { key: "FIRE_RATING", tableTh: "消防等级", name: "消防等级", fieldName: "fireRating", type: "TEXT" },
        "PROPERTY_FEE": { key: "PROPERTY_FEE", tableTh: "物业费", name: "物业费", fieldName: "propertyFee", type: "NUMBER" },
        "RENT_PROPERTY_SPLIT": {
            key: "RENT_PROPERTY_SPLIT",
            tableTh: "租金物业拆分",
            name: "租金物业拆分",
            fieldName: "rentPropertySplit",
            type: "TEXT"
        },
        "RENT_EFFECTIVE": {
            key: "RENT_EFFECTIVE",
            tableTh: "不含税有效租金报价",
            name: "不含税有效租金报价",
            fieldName: "rentEffective",
            type: "NUMBER"
        },
        "CONVERT_RENT_EFFECTIVE": {
            key: "CONVERT_RENT_EFFECTIVE",
            tableTh: "折算不含税租金面价报价",
            name: "折算不含税租金面价报价",
            fieldName: "convertRentEffective",
            type: "NUMBER"
        },
        "RENT_EFFECTIVE_TAX": {
            key: "RENT_EFFECTIVE_TAX",
            tableTh: "含税有效租金报价",
            name: "含税有效租金报价",
            fieldName: "rentEffectiveTax",
            type: "NUMBER"
        },
        "CONVERT_RENT_EFFECTIVE_TAX": {
            key: "CONVERT_RENT_EFFECTIVE_TAX",
            tableTh: "折算含税租金面价报价",
            name: "折算含税租金面价报价",
            fieldName: "convertRentEffectiveTax",
            type: "NUMBER"
        },
        "LEASE_LIST": { key: "LEASE_LIST", tableTh: "主要租户", name: "主要租户", fieldName: "leaseList", type: "TEXT" },
        "RENT_LEASE": {
            key: "RENT_LEASE",
            tableTh: "成交不含税有效租金",
            name: "成交不含税有效租金",
            fieldName: "rentSuccessful",
            type: "NUMBER"
        },
        "LAND_ACQUISITION_DATE": {
            key: "LAND_ACQUISITION_DATE",
            tableTh: "拿地时间",
            name: "拿地时间",
            fieldName: "landAcquisitionDate",
            type: "TEXT"
        },
        "PLAN_NATURE": { key: "PLAN_NATURE", tableTh: "土地性质", name: "土地性质", fieldName: "planNature", type: "TEXT" },
        "REMARKS": { key: "REMARKS", tableTh: "备注", name: "备注", fieldName: "remarks", type: "TEXT" },
    },
    Enum: {
        ZONE_NUMBER: "ZONE_NUMBER",
        BRAND_NAME: "BRAND_NAME",
        SHOW_DISTRICT: "SHOW_DISTRICT",
        ADDRESS: "ADDRESS",
        BMAP_LINK: "BMAP_LINK",
        DISTANCE: "DISTANCE",
        ZONE_NAME: "ZONE_NAME",
        BUILDING_AREA: "BUILDING_AREA",
        VACANT_AREA: "VACANT_AREA",
        VACANT_AREA_STRING: "VACANT_AREA_STRING",
        VACANT_AREA_ADJUST: "VACANT_AREA_ADJUST",
        VACANCY_RATE: "VACANCY_RATE",
        STATUS: "STATUS",
        READY_RENT_DATE: "READY_RENT_DATE",
        BUILDING_TYPE: "BUILDING_TYPE",
        FLOOR_NUM: "FLOOR_NUM",
        RENT_WITH_PROPERTY_NO_TAX: "RENT_WITH_PROPERTY_NO_TAX",
        RENT_TAX_RATE: "RENT_TAX_RATE",
        RENT_FREE_CONDITION: "RENT_FREE_CONDITION",
        FLOOR_HEIGHT: "FLOOR_HEIGHT",
        FLOOR_LOAD: "FLOOR_LOAD",
        PLATFORM: "PLATFORM",
        UNLOADING_TYPE: "UNLOADING_TYPE",
        FIRE_RATING: "FIRE_RATING",
        PROPERTY_FEE: "PROPERTY_FEE",
        RENT_PROPERTY_SPLIT: "RENT_PROPERTY_SPLIT",
        RENT_EFFECTIVE: "RENT_EFFECTIVE",

        CONVERT_RENT_EFFECTIVE: "CONVERT_RENT_EFFECTIVE",

        RENT_EFFECTIVE_TAX: "RENT_EFFECTIVE_TAX",

        CONVERT_RENT_EFFECTIVE_TAX: "CONVERT_RENT_EFFECTIVE_TAX",

        LEASE_LIST: "LEASE_LIST",
        RENT_LEASE: "RENT_LEASE",
        LAND_ACQUISITION_DATE: "LAND_ACQUISITION_DATE",
        PLAN_NATURE: "PLAN_NATURE",
        REMARKS: "REMARKS",
    }
}
export const ProposalGroupFieldEnum = {
    List: [

        { value: "", label: "WMS_BUSINESS_PROPOSAL_GROUP_TYPE_DEFAULT" },
        { value: "zoneDistrict", label: "WMS_BUSINESS_PROPOSAL_GROUP_TYPE_DISTRICT" },
        { value: 'zoneTown', label: "WMS_BUSINESS_PROPOSAL_GROUP_TYPE_TOWN" }
    ],
    Map: {
        "": "WMS_BUSINESS_PROPOSAL_GROUP_TYPE_DEFAULT",
        "zoneDistrict": "WMS_BUSINESS_PROPOSAL_GROUP_TYPE_DISTRICT",
        "zoneTown": "WMS_BUSINESS_PROPOSAL_GROUP_TYPE_TOWN"
    },
    Enum: {
        DEFAULT: "",
        ZoneDistrict: "zoneDistrict",
        ZoneTown: "zoneTown"
    }

};

export const ProposalDistrictColorArray = [
    '#001760',
    '#c5002a',
    '#00992b',
    '#934dcc',
    '#007bff',
    '#ff7d77',
];

export const ProposalDistrictColorImageArray = [
    {
        normalPath: require("../../images/bmap/location-001760.svg"),
        kingPath: require("../../images/bmap/location-king-001760.svg")
    },
    {
        normalPath: require("../../images/bmap/location-c5002a.svg"),
        kingPath: require("../../images/bmap/location-king-c5002a.svg")
    }, {
        normalPath: require("../../images/bmap/location-00992b.svg"),
        kingPath: require("../../images/bmap/location-king-00992b.svg")
    }, {
        normalPath: require("../../images/bmap/location-934dcc.svg"),
        kingPath: require("../../images/bmap/location-king-934dcc.svg")
    }, {
        normalPath: require("../../images/bmap/location-007bff.svg"),
        kingPath: require("../../images/bmap/location-king-007bff.svg")
    }, {
        normalPath: require("../../images/bmap/location-ff7d77.svg"),
        kingPath: require("../../images/bmap/location-king-ff7d77.svg")
    },

];

export const SchedulerTableName = {
    Enum: {
        BusinessOpportunity: "wms_business_opportunity",
        ResearchReport: "wms_research_report",
    }
}

export const LocationUrlQueryParam = {
    Enum: {
        City: "city",
        DistrictList: "districtList",
        VacantAreaMax: 'zoneMaxVacantArea',
        VacantAreaMin: 'zoneMinVacantArea',
        BuildingTypeList: "buildingTypeList"
    }
};

export const ZoneNearbyDataType = {
    List: [
        { value: "01", label: "收费站" },
        { value: "02", label: "火车站" },
        { value: "03", label: "WMS_ZONE_NEARBY_DATA_TYPE_TRAIN_STATION" },
        { value: "04", label: "WMS_ZONE_NEARBY_DATA_TYPE_PORT" },
    ],
    Map: {
        "01": "收费站",
        "02": "机场",
        "03": "火车站",
        "04": "港口",

    },
    Enum: {


        BillStation: "01",
        Airport: "02",
        TrainStation: "03",
        Port: "04",

    }
};


export const ZoneSortEnums = {
    List: [
        // {value: "00", label: "", name: "", sortField: "recommendOrder", sortType: "desc"},

        { value: "10", label: "距离从近到远", name: "距离近", sortField: "distance_order", sortType: "asc" },
        { value: "02", label: "价格从高到低", name: "租金多", sortField: "rent_effective", sortType: "desc" },
        { value: "01", label: "价格从低到高", name: "租金少", sortField: "rent_effective", sortType: "asc" },
        { value: "04", label: "面积从大到小", name: "面积多", sortField: "vacant_area_sum", sortType: "desc" },
        { value: "03", label: "面积从小到大", name: "面积少", sortField: "vacant_area_sum", sortType: "asc" }
    ],
    NoDistanceList: [
        "02", "01", "04", "03",

    ],
    Map: {
        "10": { value: "10", label: "距离从近到远", name: "距离近", sortField: "distance_order", sortType: "asc" },
        "02": { value: "02", label: "价格从高到低", name: "租金多", sortField: "rent_effective", sortType: "desc" },
        "01": { value: "01", label: "价格从低到高", name: "租金少", sortField: "rent_effective", sortType: "asc" },
        "04": { value: "04", label: "面积从大到小", name: "面积多", sortField: "vacant_area_sum", sortType: "desc" },
        "03": { value: "03", label: "面积从小到大", name: "面积少", sortField: "vacant_area_sum", sortType: "asc" },
        // "00": {label: "", name: "", sortField: "recommendOrder", sortType: "desc"},
    },
    Enum: {
        distanceOrder: "10",
        recommendOrder: "00",
        rentLessToMore: "01",
        rentMoreToLess: "02",
        areaLessToMore: "03",
        areaMoreToLess: "04"
    }

};

export const MapSearchRangeEnums = {
    List: [
        { value: 2, label: "2KM" },
        { value: 5, label: "5KM" },
        { value: 10, label: "10KM" },
        { value: 20, label: "20KM" },
        // {value: 30, label: "30 km内"},
        // {value: 40, label: "40 km内"},
        // {value: 50, label: "50 km内"},
    ],

    Enum: {
        RANGE_2: 2,
        RANGE_5: 5,
        RANGE_10: 10,
        RANGE_15: 15,
        RANGE_20: 20,
    }


};


export const FuzzySearchType = {
    Enums: {
        Default: "Default",
        Brand: "Brand",
        Town: "Town",
        Location: 'Location',
        // Address: 'Address',

    },
    Map: {
        Brand: { label: "品牌开发商", value: "Brand" },
        Town: { label: "子市场(乡镇)", value: "Town" },
        Location: { label: "目标位置", value: "Location" },
        // Address: {label: "地址", value: "Address"},


    }

}

export const SearchConditionTypeEnums = {
    Enums: {
        Default: "Default",
        Brand: "Brand",
        Town: "Town",
        Location: 'Location',
        Address: 'Address',

    },
    Map: {
        sort: {
            changeItems: [{ code: "sortField", defaultValue: "" },
            { code: "sortType", defaultValue: "" },
            { code: "recommendOrderFlag", defaultValue: 1 }
            ]
        },
        location: {
            changeItems: [
                { code: "zoneDistrictList", defaultValue: [] },
                { code: "mapSearchRange", defaultValue: undefined }
            ]
        },
        area: {
            changeItems: [
                { code: "zoneDistrictList", defaultValue: [] },
                { code: "mapSearchRange", defaultValue: undefined }
            ]
        },
        Location: { label: "目标位置", value: "Location" },
        Address: { label: "地址", value: "Address" },
    },
    Enum: {
        Default: "",
        Sort: "sort",
        Location: "location",
        Area: "area",
        BuildingInfo: "buildingInfo",
        DateSelect: "dateSelect",
        InfoSelect: "infoSelect",
        CitySelect: "citySelect",

    }
}
